export default {
    "incentive": {
        "tier": {
            "maintain": "Maintain tier",
            "stage": "Activeness stage",
            "graduation": "Graduation",
            "creatorActivity": "Valid live days",
            "gradLow": "Low",
            "gradMedium": "Medium",
            "gradHigh": "High",
            "incremental": "Completion stage",
            "regional": "Regional contribution",
            "regionalEarning": "Threshold reached — all members earning bonus",
            "regionalBelow": "Below threshold — raise the rate to earn"
        },
        "unit": {
            "diamonds": "diamonds",
            "days": "days",
            "hours": "hours",
            "stage": "stage"
        },
        "caption": {
            "toMaintain": "{n} diamonds needed to maintain tier",
            "toRankUp": "{n} diamonds needed to rank up",
            "toLevelUp": "{n} days and {h} needed to level up",
            "toLevelUpDays": "{n} days needed to level up",
            "toLevelUpHours": "{h} needed to level up",
            "toGraduate": "{n} diamonds needed to graduate",
            "toValidDays": "{n} days needed to reach valid live days",
            "toCompletion": "{n} diamonds needed for the next stage",
            "toContribute": "{n} days and {h} needed to become a valid creator",
            "toContributeDays": "{n} days needed to become a valid creator",
            "toContributeHours": "{h} needed to become a valid creator",
            "contributing": "Valid creator ✓ — contributing to the cohort"
        },
        "duration": {
            "hour": "hours",
            "minute": "minutes"
        },
        "push": {
            "nudge": {
                "title": "Keep going!",
                "body": "You are close to your goal. A little more effort and you will reach it."
            }
        }
    },
    "incentives": {
        "view": {
            "title": "Incentive Details",
            "subtitle": "Nudge creators close to their target, send the right notification · data: daily snapshot"
        },
        "tab": {
            "rankup": "Rank-up Incentive",
            "activeness": "Activeness Incentive",
            "incremental": "Incremental Revenue",
            "regionalTier1": "Regional · Tier 1",
            "regionalTier2": "Regional · Tier 2",
            "regionalTier3": "Regional · Tier 3+",
            "graduation": "Creator Graduation",
            "creatorActivity": "Creator Activeness"
        },
        "rail": {
            "actions": "{count} actions"
        },
        "segment": {
            "all": "All",
            "ready": "Push now",
            "atRisk": "At risk",
            "closeToUp": "Close to rank-up"
        },
        "search": {
            "user": "Search creator…",
            "manager": "Manager…"
        },
        "col": {
            "creator": "Creator",
            "bonus": "Est. bonus contribution",
            "rate": "Rate",
            "progress": "Progress",
            "validDays": "Valid days",
            "validHours": "Valid hours",
            "action": "Action"
        },
        "row": {
            "vsLastMonth": "vs last month",
            "dayShort": "d",
            "hourShort": "h",
            "levelTier": "Tier {n}",
            "levelStage": "Stage {n}",
            "diamonds": "diamonds",
            "forecastPrefix": "if leveled up",
            "condOk": "Conditions met ✓",
            "condNo": "Condition missing",
            "ready": "READY",
            "push": "Push"
        },
        "state": {
            "loading": "Loading…",
            "empty": "No creators to show."
        },
        "footer": {
            "total": "{count} creators total",
            "prev": "Previous",
            "next": "Next",
            "page": "Page {current} / {total}"
        },
        "bulk": {
            "selected": "{count} selected",
            "potential": "· ~{amount} potential",
            "selectReady": "Select ready",
            "notify": "Send Notification"
        },
        "notify": {
            "title": "Send Notification",
            "recipients": "Will be sent to {count} recipients",
            "mode": {
                "template": "Template",
                "free": "Free message"
            },
            "previewLabel": "Preview",
            "previewTitle": "Almost there 🚀",
            "preview": "Only {gap} 💎 left to your goal 🚀",
            "templateLabel": "Template",
            "templatePlaceholder": "Select a template",
            "freeMessageOption": "Free message",
            "previewHeading": "Message preview",
            "previewButton": "Preview",
            "previewLoading": "Preparing preview…",
            "previewEmpty": "No preview to show.",
            "titleLabel": "Title",
            "titlePlaceholder": "Notification title",
            "messageLabel": "Message",
            "messagePlaceholder": "Write your message…",
            "channelsLabel": "Channels",
            "channel": {
                "push": "Push",
                "sms": "SMS",
                "inApp": "In-app"
            },
            "cancel": "Cancel",
            "send": "Send",
            "sending": "Sending…",
            "toast": {
                "successTitle": "Notification sent",
                "success": "{dispatched} notifications sent, {skipped} skipped.",
                "error": "Failed to send notification."
            }
        },
        "month": {
            "0": "January",
            "1": "February",
            "2": "March",
            "3": "April",
            "4": "May",
            "5": "June",
            "6": "July",
            "7": "August",
            "8": "September",
            "9": "October",
            "10": "November",
            "11": "December"
        }
    },
    "iosBanner": {
        "title": "Haymen app",
        "desc": "Download the app for a faster, smoother experience.",
        "cta": "Get",
        "close": "Close"
    },
    "spelEditor": {
        "placeholder": {
            "default": "#user.email == 'test@example.com'"
        },
        "hint": {
            "autocomplete": "Type # for variables, . for properties"
        }
    },
    "notification": {
        "group_message": "Group Message",
        "new_message": "New Message",
        "sent_message": "Sent a message"
    },
    "i18n": {
        "toast": {
            "message": {
                "deleteError": "An error occurred while deleting the translation.",
                "saveError": "An error occurred while saving the translation.",
                "deleted": "Translation deleted successfully.",
                "saved": "Translation saved successfully.",
                "enterCustomLocale": "Please enter a valid locale code.",
                "importSuccess": "Translations imported successfully."
            },
            "error": {
                "invalidJson": "Please select a valid JSON file.",
                "readError": "File could not be read or JSON format is incorrect."
            }
        },
        "view": {
            "label": {
                "editTitle": "Edit Translation",
                "title": "Localization",
                "desc": "Manage system-wide texts and translations.",
                "createTitle": "Add New Translation",
                "description": "Manage language keys and translations for your application."
            },
            "action": {
                "deleteConfirm": "Are you sure you want to delete this translation? This action cannot be undone.",
                "create": "New Translation",
                "delete": "Delete Translation",
                "bulkUpload": "Bulk upload"
            }
        },
        "filter": {
            "module": "Module"
        },
        "table": {
            "label": {
                "value": "Translation",
                "key": "Key",
                "locale": "Locale",
                "module": "Module"
            }
        },
        "form": {
            "label": {
                "value": "Translation Text",
                "locale": "Select Locale",
                "module": "Module (Optional)",
                "key": "Language Key"
            },
            "placeholder": {
                "value": "Enter translation text here...",
                "key": "e.g. common.labels.save"
            }
        },
        "modal": {
            "action": {
                "startImport": "Start Import"
            },
            "label": {
                "bulkTitle": "Bulk Import",
                "dropZone": "Drag and drop JSON file here or click"
            },
            "message": {
                "bulkDesc": "Drag and drop your i18n JSON file here or select a file. The system will update all keys automatically."
            }
        }
    },
    "policy": {
        "toast": {
            "message": {
                "updateError": "Failed to update permissions",
                "saveError": "Failed to save policy",
                "updateSuccess": "Permissions updated",
                "deleteError": "Failed to delete",
                "roleTemplatesError": "Failed to update role templates",
                "saveSuccess": "Policy saved",
                "roleTemplatesSuccess": "Role templates updated successfully",
                "loadError": "Failed to load data",
                "deleteSuccess": "Policy deleted"
            }
        },
        "view": {
            "label": {
                "title": "Role Profile",
                "desc": "Define and enforce security policies, roles, and permission matrices.",
                "saveChanges": "Save Changes",
                "description": "Define default attribute templates for this role",
                "noTemplates": "No templates defined",
                "pageTitle": "Access Control Policies",
                "attributeTemplates": "Attribute Templates",
                "deleteMessage": "Are you sure you want to delete this policy? This action cannot be undone.",
                "deleteTitle": "Delete Policy",
                "policies": "Search policies...",
                "permissions": "Search permissions...",
                "addTemplate": "Add Template"
            },
            "tab": {
                "policies": "Attribute Policies",
                "roles": "Role Profiles",
                "matrix": "Permission Matrix",
                "users": "User – Permission"
            },
            "action": {
                "newPolicy": "New Policy"
            }
        },
        "users": {
            "usersAria": "Users",
            "permsAria": "User permissions",
            "searchUsers": "Search users",
            "searchPermissions": "Search permissions",
            "filter": {
                "manager": "Manager",
                "creator": "Creator",
                "partner": "Partner",
                "withOverrides": "With exceptions"
            },
            "empty": {
                "select": "Select a user on the left to see their permissions",
                "users": "No users found"
            },
            "summary": "Role: {role} · {granted} granted, {revoked} revoked",
            "onlyChanged": "Exceptions only",
            "col": {
                "permission": "Permission",
                "inRole": "In role",
                "forUser": "For this user"
            },
            "inRole": {
                "yes": "Yes",
                "no": "No"
            },
            "mode": {
                "role": "As role",
                "grant": "Grant",
                "revoke": "Revoke"
            },
            "save": "Save",
            "reset": "Discard",
            "toast": {
                "saved": "Permissions saved",
                "saveError": "Permissions could not be saved",
                "loadError": "Permissions could not be loaded"
            }
        },
        "form": {
            "label": {
                "core": "Core Configuration",
                "description": "Description",
                "active": "Policy Active",
                "subtitleNew": "Define new access rule",
                "subtitleEdit": "Update policy logic",
                "scope": "e.g. user:create",
                "condition": "Condition (SpEL)",
                "titleNew": "New Attribute Policy",
                "titleEdit": "Edit Policy",
                "priority": "Priority",
                "logic": "Rule Logic & Meta",
                "effect": "Effect",
                "saveBtn": "Save Configuration",
                "saving": "Saving...",
                "conditionHint": "Available: #user, #resource"
            }
        },
        "table": {
            "column": {
                "status": "Status",
                "scope": "Scope",
                "effect": "Effect",
                "role": "Role",
                "condition": "Condition",
                "permission": "Permission / Scope",
                "priority": "Priority"
            }
        }
    },
    "segments": {
        "view": {
            "action": {
                "create": "Create Segment"
            },
            "diff": {
                "empty": {
                    "title": "No changes detected",
                    "desc": "The selected versions are identical."
                },
                "filter": {
                    "showOnlyChanges": "Show only differences"
                },
                "summary": {
                    "rowsWithChanges": "Attributes Changed",
                    "modified": "Modified",
                    "added": "Added"
                }
            },
            "label": {
                "titleNew": "New Segment",
                "descEdit": "Update segment logic",
                "titleEdit": "Edit Segment",
                "title": "User Segments",
                "desc": "Manage user segments and define dynamic targeting rules.",
                "empty": "No segments found. Create your first user segment to get started.",
                "descNew": "Define new user segment",
                "noSegments": "This user isn't in any segment."
            }
        },
        "table": {
            "column": {
                "status": "Status",
                "description": "Description",
                "name": "Name",
                "code": "Code",
                "condition": "Condition"
            }
        },
        "form": {
            "label": {
                "name": "e.g. Gold Users",
                "active": "Active Status",
                "description": "Describe this segment...",
                "code": "e.g. GOLD_USERS",
                "rules": "Targeting Rules",
                "rulesDesc": "Define the logic for users to join this segment.",
                "settingsDesc": "Control segment visibility and activity.",
                "settings": "Settings",
                "activeDesc": "Enable or disable this segment globally.",
                "info": "Segment Information",
                "infoDesc": "Basic details to identify this segment."
            }
        },
        "actions": {
            "delete": "Delete Segment",
            "deleteConfirm": "Are you sure you want to delete this segment?"
        },
        "builder": {
            "label": {
                "visual": "Visual",
                "advanced": "Advanced (SpEL)",
                "noRules": "No targeting rules defined.",
                "rulesHint": "Users matching ALL rules below will join this segment.",
                "newCondition": "New Condition",
                "attribute": "Attribute",
                "operator": "Operator",
                "value": "Value",
                "true": "True",
                "false": "False"
            },
            "placeholder": {
                "rawExpression": "#user['attr'] > val",
                "selectAttribute": "Select Attribute",
                "operator": "Op",
                "enterValue": "Enter Value"
            },
            "hint": {
                "spelExample": "Write raw SpEL expressions. Example:"
            },
            "action": {
                "addCondition": "Add Condition"
            }
        },
        "placeholder": { "spelExpression": "Write a SpEL expression, for example #user.status == 'ACTIVE'" }
    },
    "notifications": {
        "view": {
            "status": {
                "active": "Active",
                "inactive": "Inactive"
            },
            "label": {
                "exclusions": "EXCLUSIONS",
                "required": "Required field",
                "createTemplate": "Create New Notification Template",
                "category": "select a category",
                "visualizer": "REALTIME VIZUALIZER",
                "mobile": "PHONE",
                "raw": "HTML / RAW",
                "subject": "HEADER SUBJECT",
                "html": "HTML BODY COMPOSITION",
                "marketing": "MARKETING",
                "editDesc": "Modify existing template configuration and visual appearance.",
                "createTitle": "Create Broadcast",
                "value": "default value",
                "desktop": "WEBSITE",
                "mappings": "DEFAULT MAPPINGS",
                "deleteTitle": "Delete Template",
                "key": "variable name",
                "pageTitle": "Notification Management",
                "editTemplate": "Edit Notification Template",
                "system": "SYSTEM",
                "newTemplate": "New Template",
                "identity": "TEMPLATE IDENTITY",
                "title": "Notification Templates",
                "identifier": "IDENTIFIER",
                "sidebarControl": "SIDEBAR CONTROL",
                "deleteMessage": "This action is permanent. Do you really want to delete this template?",
                "createDesc": "Configure identity, logic and content for your new notification template.",
                "desc": "Manage notification templates and schedule broadcast messages.",
                "attributes": "SYSTEM ATTRIBUTES",
                "security": "SECURITY",
                "search": "search templates...",
                "broadcasts": "Broadcasts",
                "totalRecipients": "Total Recipients",
                "stats": "Statistics"
            },
            "action": {
                "discard": "Discard Changes",
                "save": "Save Configuration",
                "addExclusion": "add exclusion",
                "addMapping": "add mapping"
            },
            "placeholder": {
                "search": "Search templates..."
            },
            "message": {
                "gridNotAvailable": "Grid view not available for Broadcasts yet."
            },
            "modal": { "empty": { "desc": "The selected versions are identical.", "title": "No changes found" }, "filter": { "showOnlyChanges": "Show only changes" }, "header": { "attribute": "Attribute" }, "state": { "calculating": "Comparing…" }, "subtitle": { "desc": "What changed between two data snapshots" }, "summary": { "added": "Added", "modified": "Changed", "rowsWithChanges": "Changed attributes" }, "title": { "label": "Compare versions" } }
        },
        "table": {
            "column": {
                "subject": "Subject",
                "status": "Status",
                "code": "Code",
                "type": "Type",
                "channel": "Channel",
                "name": "Broadcast Name",
                "date": "Date"
            },
            "action": {
                "actions": "Actions"
            }
        },
        "toast": {
            "message": {
                "updateSuccess": "Template updated",
                "saveError": "Failed to save template",
                "deleteSuccess": "Template deleted successfully",
                "deleteError": "Failed to delete template",
                "createSuccess": "Template created"
            }
        },
        "modal": {
            "label": {
                "subtitle": "Configure identity, logic and content for your notification template."
            }
        },
        "broadcast": {
            "createDesc": "Follow the steps to create a new broadcast.",
            "createTitle": "Create Broadcast"
        },
        "templateEditor": { "channelSaved": "Channel content saved", "channelSaveError": "Couldn't save channel content", "fallbackHint": "The DEFAULT version is used when a channel has no content of its own.", "unsaved": "Unsaved changes", "hasContent": "This channel has its own content", "loadingChannels": "Loading channels…", "noChannelContent": "This channel has no content of its own, so DEFAULT is used.", "createForChannel": "Create for this channel", "channelRowHint": "This tab is saved separately. Use the button here to save its changes.", "saveChannel": "Save this channel", "advanced": "Advanced", "exclusionsHint": "Users who match a key/value pair won't get this notification.", "variablesHint": "If a variable has no value at send time, the default you set here is used." }
    },
    "broadcast": {
        "wizard": {
            "step": {
                "channelsContent": "Channels & Content",
                "targeting": "Targeting",
                "schedule": "Schedule",
                "review": "Review"
            },
            "label": {
                "selectChannels": "Select Channels",
                "contentSource": "Content Source",
                "useTemplate": "Use Template",
                "customHtml": "Custom HTML",
                "subject": "Subject",
                "emailInAppContent": "Email / In-App Content",
                "pushContent": "Push Notification",
                "pushTitle": "Title",
                "pushBody": "Body",
                "smsContent": "SMS",
                "smsBody": "Message",
                "targetingTitle": "Target Audience",
                "allUsers": "All Users",
                "customAudience": "Custom Audience",
                "byRole": "By Role",
                "targetingExpression": "Targeting Expression",
                "audienceEstimate": "Audience Estimate",
                "reachDesc": "This broadcast will reach approximately {count} users",
                "estimateUnavailable": "Audience estimate unavailable",
                "sendNow": "Send Now",
                "scheduleLater": "Schedule Later",
                "immediately": "Immediately",
                "summary": "Summary",
                "name": "Name"
            },
            "desc": {
                "preDesigned": "Use a pre-designed template",
                "writeCode": "Write your own HTML code",
                "startImmediately": "Send immediately after creation"
            },
            "placeholder": {
                "template": "Select a template...",
                "subject": "Enter subject...",
                "pushTitle": "Enter push title...",
                "pushBody": "Enter push body...",
                "smsBody": "Enter SMS message...",
                "name": "Enter broadcast name...",
                "description": "Enter description..."
            },
            "message": {
                "reviewDisclaimer": "Please review the details above before launching. This action cannot be undone."
            },
            "action": {
                "launch": "Launch Broadcast"
            }
        }
    },
    "announcement": {
        "view": { "label": { "title": "Announcements", "desc": "Author HTML announcements, send via SMS/Push/In-app, track read stats" } },
        "table": { "title": "Title", "status": "Status", "channels": "Channels", "readRate": "Read Rate", "publishedAt": "Published", "actions": "Actions" },
        "status": { "draft": "Draft", "active": "Live", "archived": "Archived" },
        "channel": { "in_app": "In-app", "push": "Push", "sms": "SMS", "email": "Email" },
        "action": { "create": "New Announcement", "edit": "Edit", "publish": "Publish", "archive": "Archive", "stats": "Stats", "save": "Save" },
        "toast": {
            "published": "Announcement published", "publishError": "Publish failed", "archived": "Announcement archived",
            "archiveError": "Archive failed", "loadError": "Load failed", "titleRequired": "Title is required",
            "noChannels": "Select at least one channel", "saved": "Saved", "saveError": "Save failed",
            "imageRequired": "An image is required for in-app announcements", "imageUploadError": "Image upload failed"
        },
        "error": {
            "smsMultiSegment": "SMS exceeds a single segment — username and link are counted at their longest; shorten the text",
            "linkWithoutPage": "Enable the Page surface to use {link}",
            "noEnabledSurface": "At least one channel must be enabled",
            "homeSubjectRequired": "Home card needs a subject",
            "bodyRequired": "Enabled channels need a body text",
            "emailSubjectRequired": "Email subject is required",
            "unknownSurface": "Unknown channel",
            "duplicateSurface": "The same channel was sent twice"
        },
        "drawer": { "createTitle": "New Announcement", "editTitle": "Edit Announcement" },
        "field": {
            "title": "Title", "titlePlaceholder": "Announcement title", "channels": "Delivery Channels",
            "content": "HTML Content", "preview": "Live Preview", "startTime": "Start", "endTime": "End",
            "smsText": "SMS Text", "smsPlaceholder": "Haymen new announcement: {link}",
            "smsHint": "The {link} placeholder is replaced with the per-recipient link; if omitted, the link is appended at the end.",
            "pushTitle": "Push Title", "pushTitlePlaceholder": "Defaults to the announcement title if empty",
            "pushBody": "Push Message", "pushBodyPlaceholder": "New announcement published",
            "image": "Modal Image", "imagePick": "Choose Image", "imageUploading": "Uploading...",
            "imageHint": "Shown in the announcement modal on login. Recommended ratio 4:5 or 1:1, max 2MB."
        },
        "modal": { "cta": "View", "close": "Close" },
        "targeting": { "mode": "Targeting" },
        "audience": {
            "selectUsers": "Select Users",
            "searchLabel": "Search users",
            "searchPlaceholder": "Name or username…",
            "pasteLabel": "Paste usernames",
            "pastePlaceholder": "Separate by comma or newline: user1, user2 …",
            "addFromText": "Add from text",
            "unmatched": "Not found: {list}",
            "noUsers": "Select at least one user",
            "resolveError": "Could not resolve users"
        },
        "stats": {
            "label": { "title": "Announcement Stats" }, "back": "Back to announcements", "delivered": "Delivered",
            "read": "Read", "rate": "Read Rate", "trend": "Read Trend", "noData": "No reads yet",
            "modalClicked": "Clicked in Modal", "modalClosed": "Closed with X",
            "modalSoftCloses": "Outside Clicks", "modalDismissRate": "Modal Dismiss Rate"
        },
        "readers": { "title": "Readers", "name": "User", "readAt": "First Read", "ip": "IP", "device": "Device / Browser" },
        "archive": {
            "confirmTitle": "Archive announcement?",
            "confirmMessage": "\"{title}\" will be archived. Its tracked link will no longer show content. Continue?"
        },
        "publish": {
            "confirmTitle": "Publish announcement?",
            "confirmMessage": "\"{title}\" will be published and sent to the targeted creators via SMS/Push. This cannot be undone. Continue?"
        }
    },
    "survey": {
        "view": { "label": { "title": "Surveys", "desc": "Collect feedback from creators" } },
        "results": {
            "label": { "title": "Survey Results" },
            "back": "Back to surveys", "delivered": "Delivered", "responded": "Responded",
            "rate": "Response Rate", "anonNote": "This survey is anonymous — individual responses are hidden.",
            "average": "Average", "noData": "No data yet", "byProvince": "By province",
            "kanon": "Cohorts below 5 hidden", "textNote": "Open-ended answers are not summarized here",
            "viewResponses": "View responses"
        },
        "responses": { "title": "Individual responses", "anonymous": "Anonymous", "empty": "No responses yet" },
        "my": { "label": { "title": "My Surveys", "desc": "Fill out surveys assigned to you" }, "empty": "No pending surveys", "fill": "Fill out", "answered": "Answered", "upcoming": "Upcoming" },
        "respond": {
            "label": { "title": "Survey" },
            "required": "This question is required", "thanks": "Thank you!", "submitError": "Submit failed, try again",
            "backToList": "Back to my surveys", "back": "Back", "next": "Next", "submit": "Submit",
            "textPlaceholder": "Type your answer here…"
        },
        "action": { "create": "New Survey", "edit": "Edit", "publish": "Publish", "close": "Close", "results": "Results", "save": "Save" },
        "pager": { "prev": "Previous", "next": "Next" },
        "table": { "title": "Title", "status": "Status", "target": "Target", "responseRate": "Response Rate", "endTime": "Ends", "actions": "Actions" },
        "empty": { "title": "No surveys yet" },
        "chip": { "anonymous": "Anonymous", "mandatory": "Mandatory" },
        "status": { "draft": "Draft", "published": "Published", "closed": "Closed", "archived": "Archived" },
        "toast": {
            "loadError": "Failed to load", "published": "Survey published", "publishError": "Publish failed",
            "closed": "Survey closed", "closeError": "Close failed", "saved": "Saved",
            "saveError": "Save failed", "titleRequired": "Title is required"
        },
        "drawer": { "createTitle": "New Survey", "editTitle": "Edit Survey" },
        "field": {
            "title": "Title", "titlePlaceholder": "Survey title", "description": "Description",
            "anonymous": "Anonymous", "mandatory": "Mandatory (gate)", "gateMode": "Gate behavior",
            "startTime": "Start", "endTime": "End"
        },
        "gate": {
            "nag": "Reminder (dismissable)", "appBlock": "Block (force)",
            "newSurvey": "New Survey", "fill": "Fill out", "later": "Later",
            "mandatoryDesc": "You need to complete this survey to continue.",
            "optionalDesc": "A new survey has been assigned to you. Got a few minutes?",
            "more": "+{count} more survey(s) waiting"
        },
        "builder": {
            "questions": "Questions", "addQuestion": "Add question", "untitled": "(untitled)", "empty": "No questions yet",
            "type": "Type", "questionText": "Question text", "required": "Required", "options": "Options",
            "addOption": "Add option", "scale": "Scale", "branching": "Conditional display",
            "alwaysShow": "Always show", "branchValue": "value", "preview": "Live preview",
            "condShown": "Conditionally shown", "previewEmpty": "Preview appears here once you add questions"
        },
        "qtype": {
            "single_choice": "Single choice", "multi_choice": "Multiple choice", "text": "Free text", "rating": "Rating",
            "nps": "NPS", "likert": "Likert", "matrix": "Matrix", "ranking": "Ranking", "date": "Date", "number": "Number"
        },
        "targeting": {
            "mode": "Targeting", "all": "All creators", "segment": "Segment", "filter": "Filter",
            "manual": "Manual list", "event": "Event-triggered", "segmentCodes": "Segment codes",
            "userIds": "User IDs", "provinceIds": "Province IDs", "categoryIds": "Category IDs"
        }
    },
    "users": {
        "mobile": { "tiktokId": "TikTok ID", "lastLoginIp": "Last login IP" },
        "taskProgress": {
            "rankUp": {
                "title": "Rank-up Incentive",
                "headerSubtitle": "Keep your tier or climb one up",
                "level": "Tier {tier}",
                "chip": {
                    "tiers": "Tier {from} → {to}"
                },
                "subhead": {
                    "prefix": "You are at",
                    "suffix": "— pick your goal:"
                },
                "nextGoal": "Next goal",
                "instead": "instead of {value}",
                "congrats": {
                    "title": "You leveled up! 🎉",
                    "sub": "Tier {from} → {to}",
                    "earned": "earned"
                },
                "start": "Start",
                "journey": {
                    "kept": "You kept your tier ✓",
                    "toKeep": "{value} diamonds left to keep your tier"
                },
                "note": "Not additive: keep your tier for {maintain}, or level up for {upgrade}.",
                "badge": {
                    "rankedUp": "Ranked up ✓",
                    "maintain": "Keep",
                    "upgrade": "Level up",
                    "earned": "Earned ✓",
                    "nextGoal": "Next goal"
                },
                "option": {
                    "maintain": {
                        "title": "Stay at Tier {tier}",
                        "desc": "Reach {value} diamonds to keep your tier",
                        "done": "You kept your tier",
                        "doneDesc": "You secured {value}"
                    },
                    "upgrade": {
                        "title": "Climb to Tier {tier}",
                        "desc": "Reach {value} diamonds to move up a tier",
                        "done": "You leveled up",
                        "doneDesc": "You moved up a tier",
                        "lockedDesc": "Keep your tier first"
                    }
                },
                "check": {
                    "title": "Complete these",
                    "diamonds": "{value} diamonds",
                    "days": "{value} live days",
                    "hours": "{value} live hours",
                    "remainingDiamonds": "{value} left",
                    "remainingDays": "{value} days left",
                    "remainingTime": "{value} left",
                    "done": "✓"
                },
                "unit": {
                    "hoursShort": "h",
                    "minutesShort": "m"
                }
            },
            "noTaskTitle": "No task data for this month yet",
            "noTaskHint": "TikTok may not have published this month's tasks yet. Pick another month from the menu above to see past data."
        },
        "view": {
            "action": {
                "deleteUserMessage": "Are you sure you want to delete this user? This action cannot be undone.",
                "deleteUser": "Delete User",
                "editUser": "Edit User",
                "createUser": "Create User"
            },
            "label": {
                "pageTitle": "User Management",
                "title": "Users",
                "profileDescription": "Profile Description",
                "desc": "Manage system users, roles, and access credentials efficiently."
            },
            "status": {
                "inactive": "Inactive",
                "mfaEnabled": "2FA Enabled",
                "accountLocked": "Account Locked",
                "active": "Active"
            },
            "tab": {
                "managers": "Managers",
                "all": "All Users",
                "publishers": "Creators"
            }
        },
        "table": {
            "column": {
                "role": "Role",
                "attributes": "Attributes",
                "status": "Status",
                "user": "User",
                "phone": "Phone",
                "manager": "Manager",
                "segments": "Segments",
                "lastLogin": "Last Login",
                "category": "Category",
                "province": "Province",
                "district": "District"
            },
            "action": {
                "actions": "Actions"
            }
        },
        "loginPlatform": {
            "label": "Login Platform",
            "mobile": "Mobile",
            "web": "Web",
            "never": "Never logged in"
        },
        "filter": {
            "hasBackup": "Has backup accounts",
            "live": "Live now",
            "group": {
                "userInfo": "User Info",
                "location": "Location",
                "liveStatus": "Live status"
            }
        },
        "live": {
            "badge": "LIVE",
            "tooltip": "Live now · checked {minutes} min ago"
        },
        "form": {
            "label": {
                "role": "Role",
                "accountActiveDesc": "Enable or disable user access",
                "personalInfo": "Personal Information",
                "accountSettings": "Account Settings",
                "accessControl": "Access Control",
                "permissions": "Permissions (Auto-assigned by role)",
                "syncWithRole": "Sync with Role",
                "email": "Email",
                "addAttribute": "Add Attribute",
                "accountActive": "Account Active",
                "noPermissions": "No permissions",
                "firstName": "First Name",
                "mfaEnabledDesc": "Is 2FA enabled for this user? (Permanent)",
                "twoFactor": "MFA Required",
                "lastName": "Last Name",
                "syncWithRoleBtn": "Sync with Role",
                "metadata": "Metadata",
                "created": "Created",
                "contactInfo": "Contact Information",
                "lastUpdated": "Last Updated",
                "attributesTitle": "Attributes (PBAC)",
                "systemAttributes": "System Attributes (Read-Only)",
                "customAttributes": "Custom Attributes",
                "selectRole": "Select role",
                "mfaEnabled": "2FA Enabled",
                "attributesSynced": "Attributes synced with role template",
                "attributeValue": "Value",
                "attributeKey": "Attribute Key",
                "twoFactorDesc": "Ask for code on login (One-time)"
            },
            "placeholder": {
                "email": "e.g. user{'@'}example.com",
                "firstName": "e.g. John",
                "lastName": "e.g. Doe"
            }
        },
        "toast": {
            "message": {
                "createSuccess": "User created successfully",
                "updateSuccess": "User updated successfully",
                "saveError": "Failed to save user. Please try again."
            }
        },
        "linkedAccounts": {
            "title": "Linked Accounts",
            "badge": "Backup account",
            "count": "{count} backup",
            "isBackupOf": "Primary account",
            "backupsTitle": "Backup Accounts",
            "linkButton": "Link Backup Account",
            "makePrimary": "Make Primary",
            "unlink": "Unlink",
            "confirmMakePrimaryTitle": "Make this the primary account?",
            "confirmMakePrimaryBody": "{name} will become the primary account; the current primary and its other backups will be re-pointed to this account.",
            "confirmUnlinkTitle": "Unlink this account?",
            "confirmUnlinkBody": "{name} will become an independent account and its link will be removed.",
            "samePhoneSuggestions": "Accounts with the same phone number",
            "searchPlaceholder": "Search by name or username...",
            "empty": "No backup accounts linked yet.",
            "linkedSuccess": "Backup account linked successfully.",
            "unlinkedSuccess": "Account unlinked successfully.",
            "madePrimarySuccess": "Account set as primary successfully."
        },
        "stats": { "viewers": "Viewers", "peak": "Peak concurrent viewers", "newFollowers": "New followers", "gifts": "Gifts received" },
        "profile": { "tab": { "taskProgress": "Task progress", "livestreams": "LIVE sessions", "agency": "Agency" }, "openTikTok": "Open TikTok profile" }
    },
    "common": {
        "download": "Download",
        "close": "Close",
        "confirmDialog": { "ok": "Confirm" },
        "pagination": {
            "showing": "Showing {start}-{end} of {total}",
            "perPage": "{n} / Page"
        },
        "view": {
            "export": {
                "button": "Export",
                "csv": "CSV",
                "excel": "Excel",
                "failed": "Export failed",
                "empty": "No rows to export"
            },
            "label": {
                "confirm_delete": "Are you sure you want to delete this item?",
                "PHONE": "Phone",
                "DATE": "Date",
                "FILE": "File",
                "DATETIME": "Date & Time",
                "actions_title": "Actions",
                "DIAMONDS": "Diamonds",
                "USER": "User",
                "SELECT": "Select",
                "yes": "Yes",
                "error": "Error",
                "no": "No",
                "success": "Success",
                "LIVEDURATIONINLAST30D": "Live Duration (Last 30D)",
                "TIME": "Time",
                "STRING": "String",
                "not_implemented": "This feature is not implemented yet",
                "BOOLEAN": "Boolean",
                "CREATORNETWORKMANAGER": "Network Manager",
                "DIAMONDSINLAST30D": "Diamonds (Last 30D)",
                "NUMBER": "Number",
                "JOINEDTIME": "Joined Time",
                "emptyDescription": "No records to display at this time.",
                "loading": "Loading…",
                "noData": "No data found",
                "noDataDesc": "No records matching your search criteria.",
                "noResults": "No results found",
                "remaining": "left",
                "target": "Target",
                "refresh": "Refresh",
                "validationError": "Please fill in the required fields.",
                "disabled": "Disabled"
            },
            "action": {
                "search": "Search",
                "clear": "Clear",
                "cancel": "Cancel",
                "ok": "OK",
                "save": "Save",
                "viewAll": "View All",
                "delete": "Delete",
                "edit": "Edit",
                "create": "Create",
                "back": "Back",
                "confirm": "Confirm",
                "close": "Close",
                "refresh": "Refresh",
                "copyId": "Copy ID",
                "continue": "Continue",
                "update": "Update",
                "view": "View",
                "verify": "Verify",
                "show_less": "Show less",
                "show_more": "Show all",
                "move_up": "Move up",
                "move_down": "Move down",
                "details": "View details",
                "remove": "Remove",
                "saving": "Saving…",
                "copied": "Copied",
                "copy": "Copy"
            }
        },
        "button": {
            "action": {
                "show": "Show",
                "hide": "Hide",
                "cancel": "Cancel",
                "search": "Search"
            }
        },
        "action": {
            "save": "Save"
        },
        "active": "Active",
        "passive": "Passive",
        "delete": "Delete",
        "edit": "Edit",
        "error": "Error",
        "success": "Success",
        "messages": {
            "loadError": "Error loading data",
            "copied": "Copied",
            "error": "Something went wrong. Please try again."
        },
        "state": {
            "inactive": "Inactive"
        },
        "status": {
            "active": "Active",
            "inactive": "Inactive",
            "label": {
                "error": "Error",
                "success": "Success"
            }
        },
        "table": {
            "actions": "Actions"
        },
        "palette": {
            "section": {
                "navigation": "Navigation",
                "actions": "Actions"
            },
            "label": {
                "esc": "ESC",
                "noResults": "No results found for",
                "emptyHint": "Try searching for something else..."
            }
        },
        "month": {
            "0": "January",
            "1": "February",
            "2": "March",
            "3": "April",
            "4": "May",
            "5": "June",
            "6": "July",
            "7": "August",
            "8": "September",
            "9": "October",
            "10": "November",
            "11": "December"
        },
        "verify": "Verify",
        "back": "Back",
        "backToLogin": "Back to sign in",
        "goHome": "Go to home",
        "actions": { "view": "View details" },
        "drag_to_reorder": "Drag to reorder. The first image is the main one.",
        "uploading": "Uploading…",
        "click_or_drag_multiple": "Click or drag files here to upload",
        "click_or_drag": "Click or drag a file here to upload",
        "file_too_large": "The file is too large",
        "invalid_file_type": "This file type isn't supported",
        "expiresIn": "Expires in:",
        "confirm": { "delete": "Are you sure you want to delete this?" },
        "toast": { "deleted": "Deleted" },
        "label": { "active": "Active", "passive": "Inactive" },
        "fileLoadError": "Couldn't load the file",
        "unexpectedResponse": "The server sent an unexpected response (HTTP {status}). The API may be unreachable.",
        "unit": { "hourShort": "h", "minuteShort": "min", "atMinute": "min {n}" }
    },
    "profile": {
        "view": {
            "label": {
                "recentPayments": "Recent Payments",
                "videos": "Videos",
                "repTitle": "Agency Representative",
                "likes": "Likes",
                "desc": "Manage your user profile and view performance analytics.",
                "followers": "Followers",
                "monthlyEarnings": "Monthly Earnings"
            },
            "tab": {
                "overview": "Overview",
                "earnings": "Earnings",
                "security": "Security"
            }
        }
    },
    "panel": {
        "title": "Panel",
        "description": "The agency's daily command center",
        "palette": { "subtitle": "Triage and manager scorecard" },
        "common": {
            "noData": "No data",
            "loadFailed": "Failed to load the panel",
            "actionFailed": "Action failed"
        },
        "card": {
            "cycle": {
                "title": "{month} · Cycle End",
                "daysLeft": "days left",
                "payout": "Rewards settle on {date}"
            },
            "pulse": {
                "title": "Live Today",
                "ofTotal": "/ {total}",
                "sub": "Yesterday {yesterday}/{total} · valid-day avg {avg}/{target}"
            },
            "atRisk": {
                "title": "Reward at Risk",
                "managerTitle": "Needs Attention",
                "sub": "{rescuable} rows catchable · {hard} rows hard"
            },
            "requests": {
                "title": "Open Requests",
                "sub": "{reviewing} in review"
            }
        },
        "lane": {
            "risk": "Reward Slipping Away",
            "riskHint": "about to miss a threshold — sorted by reward at risk",
            "opportunity": "Almost There",
            "opportunityHint": "extra reward within reach — as important as risks",
            "compliance": "Bans & Violations",
            "complianceHint": "refreshed every 5 minutes",
            "empty": "All clear — nothing needs attention.",
            "showAll": "Show all ({n})",
            "collapse": "Collapse",
            "mutedFoot": "{count} muted rows hidden · auto-unmutes at cycle end"
        },
        "band": {
            "ON_TRACK": "On Track",
            "FEASIBLE": "Catchable",
            "HARD": "Hard",
            "LAST_CHANCE": "Last Chance",
            "IMPOSSIBLE": "Out of Reach"
        },
        "money": {
            "atRisk": "at risk",
            "opportunity": "upside",
            "dailyLoss": "daily loss"
        },
        "signal": {
            "maintainRisk": "{gapDiamonds} diamonds to keep the tier",
            "closeToUpgrade": "{gapDiamonds} diamonds to upgrade",
            "nextStage": "{gapDays} days + {gapHours} hours to the next stage",
            "nextStageDynamic": "{time} of streaming to the next stage",
            "nextStageReady": "Next stage is within reach — one short stream",
            "closeToGraduation": "{gapDiamonds} diamonds to graduation (80K)",
            "rookieWindow": "{validDays}/{validDaysTarget} valid days · {gapDays} more needed",
            "streakBreak": "No stream for {days} days",
            "diamondDrop": "Diamonds down {pct}%",
            "banNew": "LIVE access suspended",
            "banAppealed": "Appeal submitted · awaiting reply"
        },
        "detail": {
            "paceDiamonds": "daily pace {pace} · ~{projected} expected in {daysLeft} days",
            "daysHours": "{daysLeft} days to cycle end",
            "weekly": "Last 7 days: {weeklyDiamonds} diamonds · {weeklyActiveDays} active days",
            "banReason": "{policyReason}",
            "appealStatus": "Appeal status: {appealStatus}"
        },
        "subtitle": {
            "rankMaintain": "Tier {tier} · maintain",
            "rankUpgrade": "Tier {tier} → {targetTier}",
            "activeness": "Activeness task",
            "graduation": "Graduation · rookie",
            "rookie": "Rookie · 14-day window",
            "performance": "Performance signal",
            "compliance": "Violation"
        },
        "chip": {
            "tier": "Tier {tier}",
            "tierUp": "Tier {tier} → {targetTier}",
            "stage": "Stage {tier} → {targetTier}",
            "maintain": "Maintain",
            "upgrade": "Upgrade",
            "activeness": "Activeness",
            "graduation": "Graduation",
            "rookie": "Rookie",
            "window14": "14 Days",
            "performance": "Performance",
            "violation": "Violation"
        },
        "metric": {
            "dailyAvg": "Daily avg",
            "atThisPace": "At this pace",
            "last7": "Last 7 days",
            "activeDay": "Active days"
        },
        "time": {
            "days": "{n} days",
            "hours": "{n} hours",
            "minutes": "{n} minutes"
        },
        "act": {
            "days": "Days",
            "hours": "Hours",
            "diamonds": "Diamonds"
        },
        "compliance": {
            "stepBan": "Ban",
            "stepAppeal": "Appeal",
            "stepResult": "Outcome",
            "sent": "Sent",
            "notAppealed": "Not appealed!",
            "waiting": "Waiting"
        },
        "legend": {
            "title": "Catch-up status:",
            "ghost": "hatched = projected landing at current pace",
            "note": "daily pace = cycle average · $ = tier reward at stake",
            "noteNoMoney": "daily pace = cycle average"
        },
        "action": {
            "nudge": "Call to Stream",
            "violationDetail": "Details",
            "appeal": "File Appeal",
            "muteTitle": "Mute for this cycle"
        },
        "mute": { "done": "{username} muted for this cycle" },
        "nudge": {
            "title": "Call to Stream",
            "target": "An incentive nudge will be sent to {username}.",
            "template": "Template",
            "channels": "Channels",
            "channel": { "PUSH": "Push", "IN_APP": "In-app", "SMS": "SMS" },
            "noTemplates": "No template for this context — add one on the Incentive screen.",
            "sent": "{username} was called to stream",
            "failed": "Failed to send the nudge"
        },
        "admin": {
            "summary": {
                "title": "{month} · Agency Earnings",
                "lastMonthTotal": "last month total {last}",
                "moversTitle": "Top movers · last 7 days diamonds"
            },
            "health": {
                "graduation": "Graduation Rate (80K+)",
                "graduationGate": "{graduated}/{assessed} rookies · gates 3% / 15%",
                "rank": "Tier Success",
                "rankGate": "50% premium gate · {assessed} creators",
                "badMonths": "Bad-Month Streak",
                "badMonthsGate": "Termination gate: 3 in a row",
                "atRisk": "Reward at Risk",
                "atRiskGate": "{cases} cases · {rescuable} catchable"
            },
            "managers": {
                "title": "Manager Scorecard",
                "hint": "sorted by $ at risk · click a row → that manager's panel",
                "col": {
                    "manager": "Manager",
                    "portfolio": "Portfolio",
                    "diamonds": "Cycle Diamonds",
                    "atRisk": "$ at Risk",
                    "rescuable": "Catchable",
                    "critical": "Open Critical",
                    "mom": "vs Last Month"
                },
                "drill": "panel →"
            },
            "drill": { "title": "{name} — triage", "close": "Close" },
            "mode": {
                "aria": "Panel view",
                "activeMonth": "Active Month",
                "overview": "Overview"
            },
            "flow": {
                "title": "Last 7 Days",
                "hint": "joins, exits & bans",
                "bans": "New Bans · 24h",
                "bansSub": "suspended LIVE access",
                "leaves": "Left",
                "leavesSub": "quit · account closed · removed",
                "joins": "Joined",
                "joinsSub": "new creators",
                "net": "Net Change",
                "netSub": "joined − left · last week {prev}"
            }
        }
    },
    "performance": {
        "creatorTopPerformers": {
            "title": "Top Performers",
            "subtitle": "Top 10 creators — standouts of the week",
            "empty": "No standout creators yet."
        },
        "creatorAtRisk": {
            "title": "Needs Attention",
            "subtitle": "Top 10 at-risk creators — stream gaps, tier downgrade",
            "empty": "No creators at risk right now."
        },
        "openDrawer": "View performance",
        "drawer": {
            "title": "Creator Performance",
            "subtitle": "Last 30 days summary",
            "empty": "No performance data for this creator.",
            "loadFailed": "Failed to load performance data"
        },
        "section": {
            "daily": "Daily Pulse",
            "weekly": "Weekly Trend",
            "monthly": "Monthly Comparison",
            "risk": "Risk Signals",
            "trend30d": "30-Day Diamond Trend"
        },
        "metric": {
            "todayDiamonds": "Today's Diamonds",
            "todayBroadcasts": "Stream Status",
            "todayDuration": "Today's Stream Time",
            "weeklyTotal": "Weekly Total",
            "weeklyActiveDays": "Weekly Active Days",
            "weeklyAvgDaily": "Daily Avg (7d)",
            "monthlyProjection": "Month-end Projection",
            "tier": "Tier Status",
            "targetCompletion": "Target Completion",
            "streakBreak": "Stream Gap",
            "tierDowngradeRisk": "Tier Downgrade Risk",
            "personalBest": "Personal Best (week)"
        },
        "deltaLabel": {
            "vsYesterday": "vs yesterday",
            "vsLastWeek": "vs last week",
            "vsLastMonth": "vs last month"
        },
        "value": {
            "streamedToday": "Streamed today",
            "notStreamedToday": "No stream today",
            "streakActive": "Active",
            "streakBreakDays": "{days} days",
            "atRisk": "At risk",
            "safe": "Safe",
            "exceeded": "Exceeded"
        },
        "tierTrend": {
            "UP": "Up",
            "FLAT": "Same",
            "DOWN": "Down",
            "UNKNOWN": "Unknown"
        },
        "risk": {
            "streakBreak": "{days} days without a stream",
            "tierDowngrade": "Projected to drop tier this month",
            "personalBest": "Personal best this week"
        },
        "shortSignal": {
            "streak": "{days}d",
            "activeToday": "Active today",
            "tierUp": "Tier up",
            "tierRisk": "Tier risk"
        },
        "unit": {
            "diamonds": "Diamonds",
            "hours": "hr",
            "week": "week"
        }
    },
    "commandPalette": {
        "view": {
            "action": {
                "policies": "Policies",
                "segmentsSubtitle": "Manage user segments",
                "segments": "Segments",
                "logoutSubtitle": "Log out of your account",
                "profileSubtitle": "Go to your profile page",
                "analyticsSubtitle": "Data and reporting",
                "inboxSubtitle": "View messages and alerts",
                "requests": "Requests",
                "notifications": "Notifications",
                "settingsSubtitle": "App configuration",
                "analytics": "Analytics",
                "campaigns": "Campaigns",
                "settings": "Settings",
                "logout": "Sign Out",
                "inbox": "Inbox",
                "requestsSubtitle": "Approvals and review processes",
                "usersSubtitle": "Manage users and roles",
                "policiesSubtitle": "Access and permission management",
                "profile": "Profile",
                "users": "User Management",
                "campaignsSubtitle": "Marketing campaigns",
                "notificationsSubtitle": "Manage templates & broadcasts"
            },
            "label": {
                "noResults": "No results found.",
                "close": "to close",
                "placeholder": "Type a command or search...",
                "select": "to select",
                "navigate": "to navigate"
            }
        }
    },
    "requests": {
        "ruleStatus": {
            "remaining": "{n} left",
            "showSteps": "Show allowance table",
            "hideSteps": "Hide allowance table"
        },
        "list": {
            "requestedBy": "Requested By",
            "createdByLabel": "Created by: {name}"
        },
        "filter": {
            "status": "Status Filter",
            "type": "Type Filter",
            "manager": "Manager Filter"
        },
        "history": {
            "title": "Request History",
            "on_behalf_of": "on behalf of",
            "on_behalf_created": "{owner} on behalf of {creator}",
            "created_by_suffix": "created by"
        },
        "status": {
            "approved": "Approved",
            "executed": "Executed",
            "rejected": "Rejected",
            "submitted": "Submitted",
            "reviewing": "Reviewing",
            "draft": "Draft"
        },
        "view": {
            "status": {
                "status": "Status"
            },
            "label": {
                "created_at": "Created Date",
                "title": "Requests",
                "id": "Request ID",
                "updated_at": "Last Update",
                "type": "Type",
                "created_by": "Created By",
                "desc": "Manage requests and configure request types.",
                "payload": "Payload Data",
                "create_new": "Create Request",
                "select_type": "Select Request Type",
                "metadata": "Metadata",
                "actions_desc": "Actions triggered automatically upon approval.",
                "basic_info": "Basic Information",
                "basic_info_desc": "Define the name and unique code for this request type.",
                "create_success": "Request type created successfully",
                "delete_success": "Request type deleted successfully",
                "fields": "Form Fields",
                "fields_desc": "Define the fields required for this request type.",
                "key": "Field Key",
                "label": "Field Label",
                "new_field": "Add Field",
                "new_type": "New Request Type",
                "no_fields_message": "No fields defined yet",
                "required": "Required",
                "update_success": "Request type updated successfully",
                "createDesc": "Create and configure a new request type.",
                "typesDesc": "View and manage existing request types.",
                "selectTypeDesc": "Select the type of request you want to create.",
                "typesTitle": "Request Types",
                "noPayload": "No form fields",
                "history": "History",
                "noHistory": "No history yet"
            },
            "action": {
                "review": "Review",
                "reject": "Reject",
                "approve": "Approve",
                "actions": "Automated Actions"
            }
        },
        "toast": {
            "message": {
                "review_success": "Request status updated to review.",
                "reject_success": "Request rejected.",
                "approve_confirm": "Are you sure you want to approve this request?",
                "approve_success": "Request approved and actions executed successfully.",
                "review_confirm": "Are you sure you want to put this request in review?",
                "reject_confirm": "Are you sure you want to reject this request?",
                "reject_reason_prompt": "Please enter rejection reason:"
            },
            "reasonRequired": "Please add a reason"
        },
        "table": {
            "column": {
                "updated_at": "Last Update",
                "created_by": "Created By",
                "manager": "Manager",
                "code": "Code",
                "description": "Description",
                "fields_count": "Fields Count",
                "name": "Name",
                "status": "Status",
                "type": "Request type",
                "id": "Request ID",
                "createdAt": "Created",
                "updatedAt": "Updated",
                "auto_approve": "Auto-approve"
            }
        },
        "form": {
            "label": {
                "code": "Code",
                "code_placeholder": "e.g. GENERAL_REQUEST",
                "description": "Description",
                "name": "Name",
                "name_placeholder": "e.g. General Request",
                "type": "Type",
                "fieldRequired": "This field is required",
                "fieldOptional": "This field is optional",
                "checkEligibility": "Check Eligibility",
                "checking": "Checking...",
                "remoteTriggerMode": "Remote Validation Trigger",
                "triggerAuto": "Automatic (on typing)",
                "triggerButton": "Button (manual)",
                "remoteButtonLabelKey": "Button label (i18n key)",
                "remoteCheck": "Check",
                "remoteChecking": "Checking",
                "remoteCheckValid": "Eligible",
                "remoteCheckRetry": "Check again",
                "options": "Options",
                "untitledField": "Untitled Field",
                "descriptionKey": "Description key (i18n)",
                "fileOptions": "File options",
                "acceptedTypes": "Accepted file types",
                "directory": "Storage folder",
                "maxSizeMb": "Max size (MB)",
                "multipleFiles": "Allow multiple files",
                "singleFile": "Single file only",
                "currencyOptions": "Currency options",
                "currencySymbol": "Currency symbol",
                "textareaOptions": "Text area options",
                "rows": "Rows",
                "validationRules": "Validation rules",
                "addRule": "Add rule",
                "rule": "Rule",
                "value": "Value",
                "remoteUrl": "Remote validation URL",
                "messageKey": "Message key",
                "messageArgs": "Message values formula",
                "usage": "Usage allowance formula"
            },
            "placeholder": {
                "labelExample": "e.g. Video URL, Full Name, etc.",
                "keyExample": "e.g. video_url",
                "options": "Option 1, Option 2, Option 3...",
                "descriptionPlaceholder": "Enter description",
                "acceptedTypes": "image/*,.pdf,.doc",
                "directory": "requests",
                "currencySymbol": "USD, AED, Diamonds…"
            },
            "hint": {
                "optionsComma": "Add multiple options separated by commas",
                "remoteTriggerMode": "Automatic: triggers on each keystroke. Button: triggers when user clicks the button.",
                "remoteButtonLabelKey": "Leave empty to use \"Check\".",
                "fileOptions": "Leave empty to accept any file up to 5 MB.",
                "currencySymbol": "For example USD, EUR, AED or Diamonds. Leave empty for no unit.",
                "textareaRows": "Number of visible lines. The default is 4.",
                "remoteUrl": "Optional. SpEL rules use the built-in endpoint when this is empty.",
                "noValidations": "No validation rules yet.",
                "messageArgs": "Optional. Returns the values that fill {'{'}name{'}'} placeholders in the message.",
                "usage": "Optional. When set, creators see how many requests they have and how many they used before submitting."
            }
        },
        "action": {
            "label": {
                "newAction": "New Action",
                "noActions": "No automated actions defined yet.",
                "type": "Action Type",
                "config": "Configuration (JSON)",
                "actionBadge": "ACTION"
            },
            "hint": {
                "configJson": "Enter action configuration parameters as JSON."
            },
            "webhook": {
                "helper_title": "Dynamic Variables Guide",
                "section_endpoint": "Endpoint",
                "url": "Target URL (SpEL Expression)",
                "method": "Method",
                "body_mode": "Payload Mode",
                "headers": "HTTP Headers",
                "add_header": "Add Header",
                "no_headers": "No custom headers defined.",
                "body_mapping": "Custom JSON Mapping",
                "mode_full": "Full Form Data",
                "mode_mapped": "Custom JSON Mapping",
                "mode_none": "No Body",
                "mode_full_hint": "Sends the complete form submission as JSON.",
                "mode_mapped_hint": "Define specific fields and values below."
            }
        },
        "drawer": {
            "label": {
                "editTitle": "Edit Request Type",
                "auto_approve": "Auto-approve",
                "agreement": "Agreement"
            },
            "hint": { "auto_approve": "When on, requests of this type are approved or rejected automatically.", "agreement": "If set, users must accept this agreement before submitting a request of this type." },
            "placeholder": { "agreement": "Choose an agreement (optional)" },
            "option": { "no_agreement": "No agreement" }
        },
        "load_types_error": "Couldn't load request types",
        "submit_error": "Couldn't submit the request"
    },
    "layout": {
        "mobile": {
            "filter": { "showAll": "Show results", "title": "Filters", "clear": "Clear", "all": "All", "show": "Show", "showResults": "Show {n} results", "count": "{n} results", "search": "Search" },
            "actions": { "more": "More actions", "exportCsv": "Export (CSV)", "exportXlsx": "Export (Excel)" },
            "tab": { "menu": "Menu", "chat": "Chat" },
            "tabbar": { "aria": "Main navigation" },
            "menu": { "language": "Language", "profile": "My profile", "account": "Account settings" },
            "shortcut": { "eligibility": "Eligibility", "requests": "Requests", "leads": "Candidates", "violations": "Violations", "activities": "Events", "goals": "Goals", "equipment": "Equipment", "earnings": "Earnings", "chat": "Chat" }
        },
        "topnav": {
            "label": {
                "more": "More"
            }
        },
        "sidebar": {
            "label": {
                "administration": "Administration",
                "myAnalytics": "My Analytics",
                "candidates": "Creator Candidates",

                "rolesPermissions": "Roles & Permissions",
                "compliance": "Violations",
                "system": "Settings",
                "profile": "Profile",
                "panel": "Panel",
                "creatorAnalytics": "Agency Overview",
                "users": "Creators",
                "segments": "Segments",
                "website": "Website",
                "websiteCreators": "Creators",
                "websiteContent": "Content",
                "websiteApplications": "Applications",
                "websiteSettings": "Site Settings",
                "guides": "Guide Videos",
                "localization": "Localization",
                "inbox": "Inbox",
                "notifications": "Notifications",
                "chat": "Live Chat",
                "communication": "Communication",
                "support": "Support",
                "policies": "Policies",
                "management": "Management",
                "system_settings": "System Settings",
                "creator_snapshots": "Creator Snapshots",
                "violations": "All Violations",
                "managerMapping": "Manager Mapping",
                "goalTemplates": "Goal Templates",
                "myGoals": "My Goals",
                "managerGoals": "Manager Goals",
                "goalsAdmin": "Goal Management",
                "equipments": "Equipment",
                "creators": "Creators",
                "operations": "Operations",
                "revenue": "Revenue",
                "tournament": "Tournament",
                "data": "Data & Reports",
                "collapse": "Collapse sidebar"
            }
        },
        "bell": {
            "label": {
                "allFilter": "All"
            },
            "group": {
                "chat": "Chat",
                "security": "Security",
                "system": "System",
                "marketing": "Marketing",
                "info": "Info",
                "other": "Other"
            }
        },
        "view": {
            "label": {
                "viewAllNotifications": "View all notifications",
                "noNotifications": "No notifications",
                "signOut": "Sign Out",
                "markAllRead": "Mark all read",
                "settings": "Settings",
                "noNotificationsDesc": "You're all caught up! Check back later.",
                "profile": "My Profile",
                "notifications": "Notifications",
                "close": "to close",
                "navigate": "to navigate",
                "noResults": "No results found.",
                "placeholder": "Type a command or search...",
                "select": "to select",
                "settingsDesc": "Configure application preferences"
            },
            "placeholder": {
                "search": "Search..."
            },
            "action": {
                "analytics": "Analytics Dashboard",
                "analyticsSubtitle": "Data and reporting",
                "campaigns": "Campaigns",
                "campaignsSubtitle": "Marketing campaigns",
                "inbox": "Inbox",
                "inboxSubtitle": "View messages and alerts",
                "logout": "Sign Out",
                "logoutSubtitle": "Log out of your account",
                "notifications": "Notifications",
                "notificationsSubtitle": "Manage templates & broadcasts",
                "policies": "Policies",
                "policiesSubtitle": "Access and permission management",
                "profile": "Profile",
                "profileSubtitle": "Go to your profile page",
                "requests": "Requests",
                "requestsSubtitle": "Approvals and review processes",
                "segments": "Segments",
                "segmentsSubtitle": "Manage user segments",
                "settings": "Settings",
                "settingsSubtitle": "App configuration",
                "users": "User Management",
                "usersSubtitle": "Manage users and roles",
                "managerMapping": "Manager Mapping",
                "managerMappingSubtitle": "Manager ↔ TikTok email mappings",
                "goalTemplates": "Goal Templates",
                "goalTemplatesSubtitle": "Manage goal templates",
                "myGoals": "My Goals",
                "myGoalsSubtitle": "Current period progress & projection",
                "managerGoals": "Manager Goals",
                "managerGoalsSubtitle": "All managers' current-period progress",
                "goalsAdmin": "Goal Management",
                "goalsAdminSubtitle": "Templates and manager goals"
            }
        },
        "commandPalette": {
            "placeholder": "Type a command or start with {'@'} to search users...",
            "recentSearches": "Recent Searches",
        },
        "header": {
            "profileSubtitle": "Go to your profile page",
            "settingsSubtitle": "Application settings"
        },
        "settings": {
            "columnOrder": "Column Order",
            "dragToReorder": "Drag to reorder"
        }
    },
    "inbox": {
        "view": {
            "label": {
                "title": "NOTIFICATIONS",
                "desc": "View your notifications.",
                "noMessages": "No notifications found",
                "selectMessage": "Select a notification to read",
                "unread": "unread"
            },
            "placeholder": {
                "search": "Search notifications..."
            },
            "action": {
                "refresh": "Refresh"
            }
        }
    },
    "chat": {
        "message": {
            "edit": "Edit",
            "unsend": "Unsend",
            "edited": "edited",
            "unsent": "This message was unsent",
            "editing": "Edit message",
            "cancelEdit": "Cancel editing",
            "editFailed": "Message could not be edited",
            "unsendFailed": "Message could not be unsent",
            "unsendTitle": "Unsend this message?",
            "unsendConfirm": "The message is removed for everyone and replaced with \"This message was unsent\". Its attachments are deleted too."
        },
        "receipt": {
            "readBy": "Read by",
            "nobody": "Nobody yet",
            "unreadCount": "{n} haven't read yet"
        },
        "managerSeat": {
            "persona": "Yöneticin",
            "assignedBadge": "Assigned",
            "startButton": "Message Your Manager",
            "inboxTitle": "Team Inbox",
            "activeShort": "Active"
        },
        "view": {
            "label": {
                "title": "MESSAGES",
                "desc": "Chat with your network.",
                "noMessages": "No chat found",
                "noMessagesYet": "No messages yet",
                "seenBy": "Seen by {count}",
                "readBy": "Seen by:",
                "seen": "Seen",
                "loadingMore": "Loading more…",
                "today": "Today",
                "yesterday": "Yesterday",
                "typingShort": "typing…",
                "searchInChat": "Search in chat…",
                "searchCount": "{count} found",
                "reconnecting": "Reconnecting…",
                "sending": "Sending…",
                "sendFailed": "Failed to send",
                "noUserFound": "No users found",
                "menu": "Menu"
            },
            "action": {
                "newChat": "New Chat",
                "createGroup": "New Group",
                "reply": "Reply",
                "search": "Search",
                "attach": "Attach",
                "photo": "Photo",
                "emoji": "Emoji",
                "retry": "Retry"
            },
            "filter": {
                "all": "All",
                "unread": "Unread",
                "creators": "Creators",
                "groups": "Groups"
            },
            "placeholder": {
                "search": "Search in chats...",
                "searchUser": "Search people — start a chat…"
            },
            "message": {
                "notConnected": "No connection — message not sent, please try again."
            }
        },
        "status": {
            "activeNow": "Active Now",
            "offline": "Offline"
        },
        "modal": {
            "createGroup": {
                "title": "Create New Group",
                "description": "Define a new chat group for your team or friends.",
                "selectedCount": "{count} selected",
                "label": {
                    "groupName": "Group Name",
                    "addMembers": "Add Members (Optional)"
                },
                "placeholder": {
                    "groupName": "Enter group name...",
                    "search": "Search users to add..."
                },
                "action": {
                    "create": "Create Group"
                }
            },
            "addMembers": {
                "title": "Add Group Members",
                "description": "Invite new participants to this group.",
                "label": {
                    "search": "Search Users"
                },
                "placeholder": {
                    "search": "Search by name or email..."
                },
                "action": {
                    "add": "Add Members"
                }
            }
        }
    },
    "errors": {
        "view": {
            "label": {
                "generic": "An error occurred.",
                "invalidOtp": "Invalid OTP code. Please try again."
            }
        },
        "forbidden": { "title": "Access denied", "message": "You don't have permission to view this page." }
    },
    "auth": {
        "view": {
            "label": {
                "welcome": "Welcome Back",
                "signingIn": "Signing In...",
                "facebook": "Sign in with Facebook",
                "generic": "Login failed",
                "apple": "Sign in with Apple",
                "tiktok": "Sign in with TikTok",
                "copyright": "© 2026 Haymen Agency. All rights reserved.",
                "logoutSuccess": "Logged out successfully",
                "signIn": "Sign In",
                "orContinue": "OR CONTINUE WITH",
                "google": "Sign in with Google",
                "sessionExpired": "Your session has expired, please log in again.",
                "forgotPassword": "Forgot Password?",
                "rememberMe": "Remember me",
                "otpInstruction": "Please enter the 6-digit code from your authenticator app.",
                "terms": "Terms",
                "privacy": "Privacy",
                "support": "Support"
            },
            "placeholder": {
                "password": "Password",
                "email": "Email, Username or ID",
                "otp": "000 000",
                "newPassword": "New password",
                "confirmPassword": "Confirm password"
            }
        },
        "setPassword": { "title": "Set your password", "desc": "Your account for {name} is ready. Choose a password to sign in.", "descPlain": "Your account is ready. Choose a password to sign in.", "submit": "Save password", "invalid": "This invitation link is invalid or has expired. Ask your manager for a new invitation.", "success": "Password set. Redirecting to sign in…", "goLogin": "Go to sign in" }, "forgotPassword": { "sent": "We sent a reset code to your email", "step1": { "title": "Reset your password", "desc": "Enter your email and we'll send you a verification code." }, "step2": { "title": "Enter the code", "desc": "Enter the 6-digit code we sent to" }, "step3": { "title": "Set a new password", "desc": "Choose a new, strong password." }, "success": { "title": "Password updated", "desc": "Your password has been reset. Taking you to sign in…" }, "sendCode": "Send code", "verifyCode": "Verify code", "reset": "Reset password" }
    },
    "settings": {
        "title": "Settings",
        "subtitle": "Manage your application preferences and account settings",
        "tabs": {
            "profile": "Profile",
            "security": "Security",
            "notifications": "Notifications"
        },
        "notifications": {
            "title": "Notification Preferences",
            "subtitle": "Choose which notifications you want to receive on each channel. Disabled ones will not be sent to you.",
            "loading": "Loading…",
            "empty": "No notifications defined.",
            "save": "Save",
            "saving": "Saving…",
            "section": {
                "system": "System Notifications",
                "requestTypes": "Request Types",
                "requestTypes_sub": "Turning off a request type silences every notification for that type — creation, approval, rejection, status change, note added — across all stages."
            },
            "requestTypes": {
                "empty": "No active request types defined.",
                "description": "Covers every notification across this request type's lifecycle."
            },
            "column": {
                "notification": "Notification",
                "requestType": "Request Type"
            },
            "channels": {
                "IN_APP": "In-app",
                "PUSH": "Push",
                "EMAIL": "Email",
                "SMS": "SMS"
            },
            "codes": {
                "REQUEST_CREATED": "New request created",
                "REQUEST_CREATED_FOR_OWNER": "Your request was created",
                "REQUEST_APPROVED": "Request approved",
                "REQUEST_REJECTED": "Request rejected",
                "REQUEST_REVIEWING": "Request under review",
                "REQUEST_STATUS_CHANGED": "Request status changed",
                "REQUEST_NOTE_ADDED": "Note added to request",
                "USER_CREATED": "New user created",
                "VIOLATION_CREATED": "Violation recorded",
                "VIOLATION_CREATED_FOR_OWNER": "A violation was recorded against you",
                "VIOLATION_WITHDRAWN": "Violation withdrawn",
                "VIOLATION_ENDED": "Violation ended",
                "VIOLATION_APPEAL_APPROVED": "Violation appeal approved",
                "VIOLATION_APPEAL_REJECTED": "Violation appeal rejected",
                "WATCHLIST_STATUS_AVAILABLE": "A watchlist user became available",
                "WATCHLIST_STATUS_UNAVAILABLE": "A watchlist user is no longer available"
            },
            "descriptions": {
                "REQUEST_CREATED": "Sent when a user under your scope opens a new request.",
                "REQUEST_CREATED_FOR_OWNER": "Sent when a request you opened is recorded in the system.",
                "REQUEST_APPROVED": "Sent when a request you own is approved.",
                "REQUEST_REJECTED": "Sent when a request you own is rejected.",
                "REQUEST_REVIEWING": "Sent when a request you own moves into review.",
                "REQUEST_STATUS_CHANGED": "Sent when a request you own changes status outside of the cases above.",
                "REQUEST_NOTE_ADDED": "Sent when a new note is added to a request you own.",
                "USER_CREATED": "Sent when a new user under your scope is added.",
                "VIOLATION_CREATED": "Sent when a violation is recorded for a user under your scope.",
                "VIOLATION_CREATED_FOR_OWNER": "Sent when a new violation is recorded against you.",
                "VIOLATION_WITHDRAWN": "Sent when a violation against you is withdrawn.",
                "VIOLATION_ENDED": "Sent when a violation against you ends.",
                "VIOLATION_APPEAL_APPROVED": "Sent when your violation appeal is approved.",
                "VIOLATION_APPEAL_REJECTED": "Sent when your violation appeal is rejected.",
                "WATCHLIST_STATUS_AVAILABLE": "Sent when a user on the eligibility watchlist becomes available.",
                "WATCHLIST_STATUS_UNAVAILABLE": "Sent when a user on the eligibility watchlist is no longer available."
            },
            "toast": {
                "load_failed": "Failed to load notification preferences",
                "save_success": "Notification preferences saved",
                "save_failed": "Failed to save notification preferences"
            }
        },
        "profile": {
            "title": "Profile Information",
            "subtitle": "Update your personal information and password",
            "firstname": "First Name",
            "lastname": "Last Name",
            "dateOfBirth": "Date of Birth",
            "phoneNumber": "Phone Number",
            "phonePlaceholder": "+1 (XXX) XXX-XXXX",
            "changePassword": "Change Password",
            "newPassword": "New Password",
            "confirmPassword": "Confirm New Password",
            "passwordPlaceholder": "At least 6 characters",
            "confirmPasswordPlaceholder": "Re-enter your password",
            "success": "Profile updated successfully",
            "phoneVerified": "Verified",
            "phoneNotVerified": "Not Verified",
            "verifyNow": "Verify Now",
            "verifyPhone": "Verify Phone",
            "verifyPhoneDesc": "Please enter the 6-digit code sent to your phone number.",
            "verifyEmail": "Verify Email",
            "verifyEmailDesc": "Please enter the 6-digit code sent to your email address.",
            "verifySuccess": "Verification successful",
            "enterOtp": "Enter Code",
            "otpSent": "A verification code has been sent to your phone number.",
            "resendOtp": "Resend Code",
            "verifyError": "Invalid verification code",
            "error": {
                "required": "First Name and Last Name are required",
                "passwordMin": "Password must be at least 6 characters",
                "passwordMismatch": "Passwords do not match",
                "under18": "Users must be at least 18 years old",
                "generic": "An error occurred while updating profile"
            },
            "verified": "Verified"
        },
        "view": {
            "label": {
                "title": "Two-Factor Authentication",
                "dragToReorder": "Drag to reorder",
                "description": "Secure your account with two-factor authentication",
                "descriptionGoogle": "Secure your account with Google Authenticator",
                "descriptionSms": "Secure your account with SMS authentication",
                "instruction": "Enter the 6-digit code from your app",
                "columnOrder": "Column Order",
                "enabled": "Two-factor authentication is enabled on your account.",
                "enable": "Enable 2FA",
                "secretLabel": "SECRET KEY:",
                "benefit": "Protect your account from unauthorized access.",
                "methodSelection": "Choose Verification Method",
                "googleAuth": "Google Authenticator",
                "smsAuth": "SMS Authentication",
                "googleAuthDesc": "Generate secure codes using an authenticator app.",
                "smsAuthDesc": "Receive verification codes via SMS to your phone.",
                "passkeyLoading": "Confirm on your device…"
            }
        },
        "tokens": { "revoke_session_title": "Sign this user out?", "revoke_all_title": "Emergency: sign everyone out", "config": { "description": "See active sessions and take security actions." }, "emergency_desc": "Signs out every user at once. Use with care." },
        "twoFactor": { "disable": "Turn off two-factor authentication", "verifyAndEnable": "Verify and turn on", "continueToDashboard": "Continue to dashboard" }
    },
    "selfAnalytics": {
        "tabTitle": "Broadcast & Revenue Analysis",
        "title": "My Analytics",
        "subtitle": "Data refreshes every 12 hours · Times in Turkish time",
        "loadFailed": "Failed to load analytics",
        "footnote": "Comparisons are against your own history only. Diamond data comes from TikTok task cycles.",
        "tab": { "live": "LIVE Analysis", "revenue": "Revenue Analysis" },
        "live": {
            "weeklyDiamonds": "Diamonds this week",
            "weeklyDuration": "Stream time",
            "activeDays": "Active days",
            "streak": "Streak",
            "days": "days",
            "goldenHour": "Your golden hour",
            "goldenHourHint": "Streams you start around {hour} earn above your average.",
            "records": "Personal records",
            "recordDiamonds": "Most diamonds",
            "recordViewers": "Peak viewers",
            "recordLongest": "Longest stream",
            "recordFollowers": "New followers in one stream",
            "pkImpact": "PK impact",
            "normal": "Normal",
            "sessions": "streams",
            "pkHint": "Your PK matches earn {pct}% {dir} per hour.",
            "more": "more",
            "less": "less",
            "engagement": "Audience engagement",
            "watchRetention": "Watch retention",
            "gifterRate": "Gifting viewers",
            "commentRate": "Commenting viewers",
            "newFollowersPerSession": "New followers per stream",
            "engagementWindow": "Last 90 days · {n} streams",
            "whenYouStream": "When you stream",
            "recentSessions": "Recent streams",
            "record": "Record",
            "noSessions": "No stream data yet.",
            "heartbeat": {
                "title": "Stream heartbeat",
                "metric": "Diamonds per minute",
                "gift": "Big gift",
                "viewers": "Viewers",
                "gifters": "Gifters",
                "bigGifts": "Big gift moments",
                "noData": "No minute-level data for this stream (only recent streams have it)."
            }
        },
        "revenue": {
            "cycle": "cycle",
            "daysLeft": "{n} days left",
            "diamonds": "diamonds",
            "target": "Target",
            "projection": "Month-end projection",
            "tier": "Your revenue tier",
            "tierUp": "Tier up!",
            "tierRisk": "Downgrade risk",
            "lastMonth": "Last month",
            "monthly": "Monthly diamonds",
            "bestMonth": "Best month",
            "earnings": "Your bonus earnings",
            "paid": "PAID",
            "projected": "PROJECTED",
            "noEarnings": "No bonus records yet.",
            "taskBreakdown": "Diamonds by task",
            "taskType": {
                "RANK_UP": "Rank-Up",
                "ACTIVENESS": "Activeness",
                "COMMISSION": "Commission",
                "INCREMENTAL_REVENUE": "Incremental Revenue"
            },
            "type": {},
            "validity": "Validity targets",
            "validDays": "Valid days",
            "validHours": "Valid hours",
            "noValidity": "No targets defined for this cycle."
        }
    },
    "analytics": {
        "title": "Agency Overview",
        "description": "A creator's full historical picture",
        "loadFailed": "Failed to load analytics",
        "footnote": "Sources: live sessions (12h), task snapshots (30m), earning items (on distribution). Voice-stream split unlocks once the TikTok source is added. Hour breakdowns use Türkiye time.",
        "search": {
            "placeholder": "Search creator (username)…",
            "addCompare": "Add creator to compare…"
        },
        "empty": {
            "title": "Pick a creator",
            "sub": "Pick a creator to open the full history; pick 2-3 to switch to comparison."
        },
        "agency": {
            "title": "Agency Overview",
            "sub": "{n} distinct creators contributed to all-time revenue (incl. departed)",
            "topRevenue": "Top Revenue · Top 5",
            "topSessions": "Most Hours Live · Top 5",
            "topRisers": "Rising · Top 5",
            "topFallers": "Falling · Top 5",
            "topEmpty": "No data yet",
            "more": "View all",
            "topDeparted": "Departed · Lost Revenue",
            "searchPlaceholder": "Search creator…",
            "countLabel": "{n} creators",
            "hoursVal": "{n} h",
            "hoursDetail": "{s} streams · {d} days",
            "info": {
                "topSessions": "Ranked by TOTAL live duration (stream count misleads: many short streams can trail few long ones). Stream and day counts shown per row.",
                "topRisers": "Last closed month revenue − revenue of the creator's FIRST closed month. Net growth since joining; the current month is excluded.",
                "topFallers": "Last closed month revenue − the creator's PEAK month. How far they fell from their own peak; current month excluded.",
                "topDeparted": "Departed creator's peak monthly revenue = monthly revenue lost. Excluded from Rising/Falling lists.",
                "topDebt": "Creators whose wallet balance is positive, meaning the agency owes them this amount. Active creators only. Pending balance isn't included.",
                "topReceivable": "Creators whose wallet balance is negative, meaning they owe the agency. Active creators only. Pending balance isn't included."
            },
            "heatTitle": "When do streams happen most? (day × hour, TR time)",
            "heatBusiest": "Busiest slot: {at}",
            "diamondsVal": "{n}",
            "section": { "perf": "Performance and trends", "wallet": "Wallet and finance" },
            "topDebt": "Agency owes · Top 5",
            "topReceivable": "Most in debt · Top 5"
        },
        "day": { "mon": "Mon", "tue": "Tue", "wed": "Wed", "thu": "Thu", "fri": "Fri", "sat": "Sat", "sun": "Sun" },
        "heat": { "low": "low", "high": "high" },
        "id": {
            "tier": "Tier {t}",
            "manager": "Manager: {m}",
            "joined": "Joined {d} · {days} days",
            "sessions": "{n} streams",
            "active": "Active",
            "inactive": "Inactive"
        },
        "verdict": {
            "class": { "RISING": "RISING CREATOR", "STABLE": "STABLE CREATOR", "FALLING": "DECLINING" },
            "trend": "Revenue trend: {pct} vs last closed month",
            "consistency": "Consistency: streams {days} days/week",
            "risk": "Risk: {n} violations in 90 days",
            "reco": {
                "RISING": "Support them: protect momentum, push toward the next tier",
                "STABLE": "Watch them: small goals can build momentum",
                "FALLING": "Needs attention: discuss the decline, make a plan"
            }
        },
        "type": {
            "ACTIVENESS": "Monthly (Activeness)",
            "RANK_UP": "Tier Bonus",
            "INCREMENTAL_REVENUE": "Incremental Revenue",
            "COMMISSION": "Commission",
            "ROOKIE_MILESTONE": "Rookie & Support",
            "OTHER": "Other"
        },
        "badge": { "record": "RECORD", "low": "LOWEST" },
        "session": { "duration": "Duration", "diamonds": "Diamonds", "peak": "Peak viewers" },
        "revenue": {
            "title": "Revenue",
            "hint": "what they earn the agency · diamonds + USD",
            "total": "Total Revenue",
            "totalSuffix": "diamonds · {usd}",
            "totalSub": "since joining",
            "monthlyAvg": "Monthly Average",
            "monthlyAvgSub": "over closed months",
            "bestMonth": "Best Month",
            "worstMonth": "Weakest Month",
            "monthlyChart": "Monthly Revenue",
            "partialNote": "* current month in progress",
            "byType": "Revenue by Type",
            "byHour": "Revenue by Hour · diamonds by stream start hour",
            "peakWindow": "3 hours around {h}:00 carry {pct}% of revenue",
            "pkTitle": "PK vs Normal Stream Yield",
            "pkLabel": "PK stream",
            "normalLabel": "Normal",
            "pkNote": "{count} PK streams ({share}%)",
            "pkNoData": "No PK data yet — appears once session-level PK info lands in the data source",
            "sesPlaceholder": "Voice-stream split appears here once the TikTok source is added",
            "bestSession": "Highest-Earning Stream",
            "worstSession": "Lowest-Earning Stream"
        },
        "expense": {
            "title": "Expenses",
            "hint": "what the agency pays the creator",
            "total": "Total Paid",
            "totalSub": "monthly + bonus + support",
            "bestMonth": "Highest Month",
            "worstMonth": "Lowest Month",
            "ratio": "Expense / Revenue",
            "kept": "Kept by agency",
            "paid": "Paid out"
        },
        "broadcast": {
            "title": "Broadcast Analysis",
            "hint": "from the session series · refreshed every 12h",
            "totalHours": "Total Stream Time",
            "hoursSuffix": "hours",
            "sessions": "across {n} streams",
            "avg": "Average Stream",
            "avgSub": "per session",
            "frequency": "Stream Frequency",
            "freqSuffix": "days/week",
            "freqSub": "since joining",
            "longest": "Longest Single Stream",
            "heatTitle": "Day × Hour Density · hours on air",
            "busiest": "Busiest: {at}",
            "monthlyChart": "Monthly Stream Hours",
            "mostViewed": "Most Viewed",
            "leastViewed": "Least Viewed",
            "peakBadge": "PEAK {n}"
        },
        "cmp": {
            "lead": "Leads",
            "g": { "revenue": "Revenue", "broadcast": "Broadcast", "efficiency": "Efficiency" },
            "score": "Overall score",
            "totalRevenue": "Total revenue (USD)",
            "trend": "Monthly revenue trend",
            "monthlyAvg": "Monthly average",
            "expenseRatio": "Expense / revenue",
            "totalHours": "Total stream time",
            "frequency": "Frequency (days/week)",
            "diamondsPerHour": "Diamonds / hour",
            "pk": "PK share · yield",
            "recommendation": "Recommendation",
            "tier": "Tier {t}",
            "footnote": "Green cell = leader on that metric · lower wins on expense/revenue"
        },
        "view": {
            "label": {
                "monthly": "Monthly",
                "weekly": "Weekly",
                "subtitle": "Overview of system activity and performance.",
                "productivity": "Productivity Score",
                "daily": "Daily",
                "title": "Analytics Dashboard",
                "desc": "Overview of system activity and performance."
            }
        },
        "heartbeat": { "ariaLabel": "Minute-by-minute LIVE chart" }
    },
    "notificationTemplates": {
        "view": {
            "label": {
                "title": "Templates"
            }
        }
    },
    "matrix": {
        "view": {
            "label": {
                "title": "Permission Matrix"
            }
        }
    },
    "roles": {
        "admin": "Admin",
        "manager": "Manager",
        "creators": "Creator",
        "partner": "Partner",
        "view": {
            "label": {
                "title": "Role Management"
            }
        }
    },
    "attr": {
        "user": {
            "profile": {
                "city": "City",
                "lastIp": "Last IP Address",
                "deviceInfo": "Device Information"
            }
        }
    },
    "user.task": "Task Details",
    "user.task.header.title": "Task Information",
    "user.task.incremental.title": "Incremental Revenue Task",
    "user.task.activeness.title": "Activeness Task",
    "user.task.remaining.days": "{days} days left",
    "user.task.status.completed": "Completed",
    "user.task.unit.diamonds": " Diamonds",
    "user.task.unit.days": " Day",
    "user.task.unit.hours": " Hour",
    "user.task.commission.title": "Commission Task",
    "user.task.rank_up.title": "Rank Up Task",
    "user.profile.tiktokUsername": "TikTok Username",
    "user.profile.publicName": "Public Name",
    "user.profile.instagram": "Instagram",
    "user.profile.followers": "Followers",
    "user.profile.likes": "Likes",
    "user.profile.videoCount": "Video Count",
    "user.profile.lastLive": "Last Live",
    "user.profile.bio": "Bio",
    "user.agency.managerEmail": "Manager Email",
    "user.agency.language": "Language",
    "user.agency.invitationType": "Invitation Type",
    "user.agency.graduationStatus": "Graduation Status",
    "user.agency.baselineRevenueTargetInDiamond": "Baseline Revenue Target In Diamond",
    "user.agency.manageStartDate": "Manage Start Date",
    "user.agency.manageEndDate": "Manage End Date",
    "user.livestreams.timing.startTime": "Date",
    "user.livestreams.ongoing.badge": "Live",
    "user.livestreams.ongoing.soFar": "so far",
    "user.livestreams.ongoing.note": "Stream in progress; values will update when it ends.",
    "user.livestreams.timing.durationSeconds": "Duration",
    "user.livestreams.performance.label": "Performance",
    "user.livestreams.performance.viewers": "Viewers",
    "user.livestreams.performance.peak": "Peak",
    "user.livestreams.performance.impressions": "Impressions",
    "user.livestreams.engagement.label": "Engagement",
    "user.livestreams.engagement.followers": "Followers",
    "user.livestreams.engagement.gifts": "Gifts",
    "user.livestreams.engagement.senders": "Senders",
    "user.livestreams.revenue.diamonds": "Revenue",
    "user.livestreams.features.label": "Features",
    "task.activeness": "Activeness Task",
    "task.commission": "Commission Task",
    "task.incremental_revenue": "Incremental Revenue Task",
    "task.rank_up": "Rank Up Task",
    "task.rookie_milestone": "Rookie Milestone Bonus",
    "taskProgress.title": "Task Progress",
    "taskProgress.earnings": "Earnings",
    "taskProgress.earnings.projected": "Projected",
    "taskProgress.earnings.confirmed": "Confirmed",
    "taskProgress.earnings.credited": "Credited",
    "taskProgress.earnings.total": "Total Earnings",
    "taskProgress.earnings.breakdown": "Earnings Breakdown",
    "taskProgress.stage": "Stage",
    "taskProgress.stage.current": "Current",
    "taskProgress.stage.completed": "Completed",
    "taskProgress.stage.upcoming": "Upcoming",
    "taskProgress.stage.reward": "Reward",
    "taskProgress.metrics.totalDiamonds": "Total Diamonds",
    "taskProgress.metrics.incrementalDiamonds": "Incremental Diamonds",
    "taskProgress.metrics.broadcastDays": "Broadcast Days",
    "taskProgress.metrics.broadcastDuration": "Broadcast Duration",
    "taskProgress.metrics.rewardIncome": "Reward Income",
    "taskProgress.noData": "No task data found for this period.",
    "wallet.title": "Wallet",
    "wallet.availableBalance": "Available Balance",
    "wallet.partner.totalWithdrawn": "Total withdrawn",
    "wallet.partner.requestWithdrawal": "Withdrawal request",
    "wallet.enums.transactionType.EARNING_CREDIT.PARTNER_PAYOUT": "Partner share",
    "wallet.totalPaid": "Total Paid",
    "wallet.available": "Available Balance",
    "wallet.pending": "Pending Balance",
    "wallet.totalEarned": "Total Earned",
    "wallet.totalWithdrawn": "Total Withdrawn",
    "wallet.addDiamond": "Add Diamonds",
    "wallet.diamondCreditSuccess": "Diamonds credited successfully",
    "wallet.transactions.title": "Account Transactions",
    "wallet.transactions.column.date": "Date",
    "wallet.transactions.column.type": "Transaction Type",
    "wallet.transactions.column.amount": "Amount",
    "wallet.transactions.column.balanceAfter": "Balance",
    "wallet.transactions.column.referenceType": "Reference",
    "wallet.transactions.column.description": "Description",
    "wallet.transactions.noData": "No transactions found.",
    "wallet.enums.transactionType.EARNING_CREDIT": "Earning Credit",
    "wallet.enums.transactionType.WITHDRAWAL": "Withdrawal",
    "wallet.enums.transactionType.ADJUSTMENT": "Adjustment",
    "wallet.enums.transactionType.REWARD": "Reward",
    "wallet.enums.transactionType.SUPPORT_GIFT": "Support Gift",
    "wallet.enums.transactionType.EQUIPMENT_PURCHASE": "Equipment Allocation",
    "wallet.enums.transactionType.EQUIPMENT_RETURN": "Equipment Return",
    "wallet.enums.transactionType.LEGACY_EARNING": "Legacy Earning",
    "wallet.enums.transactionType.LEGACY_PAYOUT": "Legacy Payout",
    "equipment": {
        "drawer": {
            "title": {
                "detail": "Equipment Details"
            }
        },
        "catalog": { "error": { "load": "Couldn't load equipment.", "shipmentAddressRequired": "Please enter a delivery address.", "submit": "Couldn't create the request." }, "toast": { "requested": "Your equipment request was sent." }, "title": "Equipment catalog", "section": { "catalog": "Catalog", "requests": "My requests", "assignments": "Assigned to me" }, "description": "Browse equipment, request what you need and keep track of what's assigned to you.", "search": "Search by product, brand or category…", "empty": "No equipment is available to request right now.", "productLink": "Product link", "action": { "detail": "Details", "request": "Request" }, "requests": { "empty": "You haven't requested any equipment yet.", "unit": "pcs" }, "assignments": { "empty": "Nothing is assigned to you right now.", "active": "Active quantity" }, "requestDialog": { "title": "Equipment request", "description": "Fill in the details and submit your request.", "section": { "product": "Product summary", "request": "Request details" }, "quantity": "Quantity", "shipmentAddress": "Delivery address", "shipmentAddressPlaceholder": "Where should we send it?", "note": "Note", "notePlaceholder": "Anything we should know? (optional)", "confirm": "Send request" }, "detail": { "description": "See every photo and detail of this catalog item." } },
        "agreement": { "error": { "load": "Couldn't load the agreement.", "accept": "Couldn't accept the agreement." }, "title": "Equipment agreement", "description": "Please read and accept the agreement below before you continue.", "version": "Version", "checkbox": "I have read and accept the agreement", "action": { "accept": "Accept and continue" } },
        "category": { "drawer": { "title": { "edit": "Edit category", "create": "New category" } }, "toast": { "saved": "Category saved" } },
        "label": { "count": "Equipment count" },
        "page": { "title": "Equipment", "description": "Agency equipment and assets" }
    },
    "interaction": {
        "enums": {
            "type": {
                "CALL": "Call",
                "NOTE": "Note",
                "MESSAGE": "Message",
                "MEETING": "Meeting",
                "SYSTEM": "System",
                "AGENCY_REMOVAL": "Agency Removal"
            },
            "outcome": {
                "ANSWERED": "Answered",
                "NO_ANSWER": "No answer",
                "BUSY": "Busy",
                "LEFT_VOICEMAIL": "Voicemail left",
                "CALLBACK_SCHEDULED": "Callback scheduled"
            }
        }
    },
    "wallet.enums.referenceType.MANAGER_SUPPORT": "Agency Support",
    "wallet.supportGift.button.title": "Record Support Diamonds",
    "wallet.supportGift.drawer.title": "Support Diamonds",
    "wallet.supportGift.drawer.description": "Record a support gift without affecting balance.",
    "wallet.supportGift.drawer.descriptionFor": "Record a support gift for {name} without affecting balance.",
    "wallet.supportGift.field.amount": "Diamond Amount",
    "wallet.supportGift.field.amountPlaceholder": "e.g. 23,500 💎",
    "wallet.supportGift.field.note": "Note (optional)",
    "wallet.supportGift.field.notePlaceholder": "e.g. May 12 live stream support",
    "wallet.supportGift.action.save": "Save",
    "wallet.supportGift.balanceInfo": "This entry does not affect the creator's balance — it only appears in the transaction history.",
    "wallet.supportGift.offBalanceNote": "(no balance change)",
    "wallet.supportGift.toast.success": "Support gift recorded.",
    "wallet.supportGift.toast.error": "Failed to record support gift.",
    "wallet.enums.referenceType.MONTHLY_EARNING_CREDIT": "Monthly Earning",
    "wallet.enums.referenceType.TASK_COMPLETION": "Task Completion",
    "wallet.enums.referenceType.ADMIN_ADJUSTMENT": "Admin Adjustment",
    "wallet.enums.referenceType.BONUS": "Bonus",
    "wallet.enums.referenceType.DIAMOND_REQUEST": "Diamond Request",
    "wallet.enums.referenceType.REQUEST": "Request Action",
    "wallet.enums.referenceType.REFERRAL_EARNING_CREDIT": "Referral Earning",
    "wallet.enums.referenceType.BIRTHDAY_BONUS": "Birthday Bonus",
    "wallet.enums.referenceType.EQUIPMENT_REQUEST": "Equipment Request",
    "wallet.enums.referenceType.EQUIPMENT_ASSIGNMENT": "Equipment Assignment",
    "wallet.enums.referenceType.AGENCY_ACTIVITY": "Agency Activity",
    "wallet.description.monthlyEarningCredit": "Monthly Earning Credit",
    "wallet.description.requestCredit": "Request Approval - Diamond Credit",
    "wallet.description.requestDebit": "Request Approval - Diamond Debit",
    "wallet.description.adminAdjustment": "Admin Adjustment",
    "wallet.description.birthdayBonus": "Birthday Bonus",
    "wallet.description.purchase.equipment": "Allocated Equipment Cost",
    "wallet.description.return.equipment": "Returned Equipment Refund",
    "wallet.description.agencyActivityReward": "Agency Activity Reward",
    "agencyActivities": {
        "view": {
            "label": {
                "title": "Agency Activities",
                "description": "Track TikTok agency activities and performance data.",
                "ongoing": "Ongoing Activities",
                "completed": "Completed Activities",
                "cancelled": "Cancelled"
            }
        },
        "info": {
            "empty": "No technical details found for this activity.",
            "label": {
                "avgDiamonds": "Avg Diamonds per Member"
            },
            "section": {
                "stats": "Performance Summary",
                "prompt": "Activity Description"
            }
        },
        "ranking": {
            "title": "Participant Ranking",
            "desc": "Latest participant performances and rankings for this activity.",
            "table": {
                "column": {
                    "rank": "Rank",
                    "host": "Host",
                    "diamonds": "Diamonds",
                    "pk": "PK (Won/Total)",
                    "duration": "Live Duration",
                    "tasks": "Completed Tasks",
                    "progress": "Progress"
                }
            }
        },
        "filter": {
            "allTypes": "All Types"
        },
        "type": {
            "PK_BRACKET": "PK Bracket",
            "RANK_LIST": "Leaderboard",
            "TASK": "Task Event",
            "OTHER": "Other"
        },
        "status": {
            "upcoming": "Upcoming",
            "ongoing": "Ongoing",
            "settling": "Settling",
            "completed": "Completed",
            "cancelled": "Cancelled"
        },
        "button": {
            "scrapeNow": "Sync Now",
            "scraping": "Syncing..."
        },
        "list": {
            "title": "Activities ({count})",
            "empty": "No activities found."
        },
        "detail": {
            "empty": "Select an activity to view details.",
            "unsupportedType": "Detail view for this activity type is not supported yet.",
            "openInTikTok": "Open in TikTok",
            "stat": {
                "members": "Members",
                "totalDiamonds": "Total Diamonds",
                "start": "Start",
                "end": "End",
                "pkPairs": "PK Pairs"
            }
        },
        "toast": {
            "listError": "Failed to load activity list.",
            "detailError": "Failed to load activity detail.",
            "scrapeStarted": "Sync started.",
            "scrapeError": "Failed to start sync."
        },
        "bracket": {
            "desc": "Match bracket schema and broadcaster performances.",
            "tab": {
                "schema": "Bracket",
                "participants": "Participants"
            },
            "roundLabel": "Round {num}",
            "stat": {
                "rounds": "Rounds",
                "pairs": "Matches",
                "completed": "Completed",
                "participants": "Participants",
                "champion": "Champion"
            },
            "pair": {
                "completed": "Ended",
                "live": "Live",
                "scheduled": "No match",
                "tbd": "TBD"
            },
            "round": {
                "final": "Final",
                "semifinal": "Semifinal",
                "quarterfinal": "Quarterfinal",
                "notStarted": "Not started",
                "live": "In progress",
                "ended": "Ended"
            },
            "empty": {
                "rounds": "No rounds defined yet.",
                "pairs": "No pairs in this round."
            },
            "col": {
                "host": "Host",
                "manager": "Manager",
                "group": "Group",
                "diamond": "Diamond",
                "pkCount": "PK",
                "winCount": "Wins",
                "winRate": "Win Rate",
                "highestRound": "Highest Round",
                "champion": "Champion"
            }
        },
        "table": {
            "column": {
                "name": "Activity Name",
                "rank": "Rank",
                "score": "Diamond/Score",
                "status": "Status",
                "startTime": "Start",
                "endTime": "End",
                "totalDiamonds": "Total Diamonds",
                "memberCount": "Member Count",
                "type": "Type",
                "actions": "Actions"
            },
            "action": {
                "ranking": "Ranking",
                "info": "Activity Details",
                "bracket": "Bracket"
            }
        },
        "transfer": {
            "action": {
                "button": "Transfer Earnings",
                "submit": "Transfer ({count})"
            },
            "drawer": {
                "title": "Transfer Earnings",
                "description": "Transfer diamond-based earnings to broadcasters who joined this activity.",
                "descriptionFor": "Transfer earnings to broadcasters who joined \"{name}\"."
            },
            "search": {
                "placeholder": "Search broadcaster (name or username)..."
            },
            "list": {
                "loading": "Loading participants...",
                "empty": "No participants to show for this activity."
            },
            "badge": {
                "unmatched": "Unmatched — transfer not available",
                "alreadyTransferred": "Already transferred",
                "alreadyTransferredAmount": "Already transferred ({amount} 💎)"
            },
            "field": {
                "diamondsPlaceholder": "Diamond amount"
            },
            "info": {
                "conversion": "The diamonds you enter are converted to USD on the server and credited to the wallet."
            },
            "confirm": {
                "title": "Are you sure?",
                "message": "Earnings will be transferred to {count} selected broadcaster(s). This action cannot be undone.",
                "confirmText": "Transfer"
            },
            "toast": {
                "success": "Earnings transferred to {count} broadcaster(s).",
                "alreadyTransferred": "{count} broadcaster(s) were already paid and were skipped.",
                "skipped": "{count} item(s) were invalid and were skipped.",
                "loadError": "Failed to load participants.",
                "error": "Earnings transfer failed."
            }
        },
        "ranklist": {
            "empty": "No participants in this activity.",
            "filter": {
                "agent": "Manager",
                "agentPlaceholder": "manager@haymen.com.tr",
                "group": "Group",
                "groupPlaceholder": "Group name",
                "apply": "Apply",
                "clear": "Clear",
                "total": "{count} participants total"
            },
            "col": {
                "rank": "Rank",
                "host": "Host",
                "manager": "Manager",
                "group": "Group",
                "diamond": "Diamond",
                "score": "Score",
                "pkCount": "PK",
                "liveDuration": "Live Duration"
            },
            "pagination": {
                "prev": "Previous",
                "next": "Next",
                "page": "Page {current} / {total}"
            }
        }
    },
    "violations": {
        "view": {
            "label": {
                "title": "Violations",
                "description": "Track TikTok creator violations and penalty records.",
                "all": "All Violations"
            }
        },
        "table": {
            "column": {
                "anchor": "Creator",
                "punishTime": "Penalty Date",
                "penaltyEndTime": "End Date",
                "punishType": "Penalty Type",
                "currentStatus": "Current Status",
                "punishStatus": "Punish Status",
                "appealStatus": "Appeal Status",
                "content": "Violation Content",
                "actions": "Actions"
            },
            "action": {
                "info": "Violation Details"
            }
        },
        "info": {
            "title": "Violation Details",
            "section": {
                "violation": "Violation Info",
                "video": "Video Details",
                "appeal": "Appeal Info"
            },
            "label": {
                "context": "Violation Context",
                "reason": "Violation Reason",
                "rejectionReason": "Rejection Reason",
                "canAppeal": "Can Appeal"
            }
        },
        "enums": {
            "punishType": {
                "LIVE_ACCESS_SUSPENDED": "LIVE access suspended",
                "MULTI_GUEST_SUSPENDED": "Multi-guest suspended",
                "ACCOUNT_SUSPENDED": "Account suspended",
                "UNKNOWN": "Unknown",
                "GIFT_ACCESS_SUSPENDED": "Gifting suspended",
                "NR_GIFT_ACCESS_SUSPENDED": "LIVE visibility restricted + gifting suspended",
                "GIFT_ACCESS_SUSPENDED_ROOM_LEVEL": "Gifting suspended (Single LIVE)",
                "NR_GIFT_ACCESS_SUSPENDED_ROOM_LEVEL": "LIVE visibility restricted + gifting suspended (Single LIVE)"
            },
            "currentStatus": {
                "IN_EFFECT": "In effect",
                "WITHDRAWN": "Withdrawn",
                "ENDED": "Ended",
                "UNKNOWN": "Unknown"
            },
            "appealStatus": {
                "NOT_APPEALED": "Not appealed",
                "APPROVED": "Approved",
                "NOT_APPROVED_OPEN": "Not approved, open to inquiry",
                "INQUIRY_ONGOING": "Creator Network inquiry ongoing",
                "NOT_APPROVED": "Not approved",
                "UNKNOWN": "Unknown",
                "NOT_APPEALED_OPEN": "Not appealed, open to inquiry",
                "APPEAL_ONGOING_OPEN": "In review, open to inquiry"
            },
            "punishStatus": {
                "ACTIVE": "Active",
                "APPEALED": "Appealed",
                "APPEAL_REJECTED": "Appeal Rejected",
                "APPEAL_ACCEPTED": "Appeal Accepted",
                "UNKNOWN": "Unknown",
                "null": "No Punishment"
            },
            "clipStatus": {
                "AVAILABLE": "Available",
                "EXPIRED": "Expired",
                "RESTRICTED": "Restricted",
                "UNKNOWN": "Unknown"
            }
        }
    },
    "completeProfile": {
        "title": "Complete Your Profile",
        "subtitle": "Enter your details to continue",
        "recoveryTitle": "Let's Refresh Your Details",
        "recoverySubtitle": "We will only ask this once",
        "recoveryNoticeTitle": "We are sorry",
        "recoveryNoticeText": "We need to verify some of your account details again. Please re-enter your first name and last name. If you want, you can also update your email address on this screen.",
        "recoveryRealNameNote": "Please enter the real name you use in official records. This information will be important for operational processes such as future equipment deliveries.",
        "recoverySubmit": "Update My Details",
        "firstname": "First Name",
        "lastname": "Last Name",
        "email": "Email",
        "emailPlaceholder": "Enter your email address",
        "dateOfBirth": "Date of Birth",
        "phoneNumber": "Phone Number",
        "phonePlaceholder": "+1 (XXX) XXX-XXXX",
        "province": "Province",
        "provincePlaceholder": "Select province",
        "district": "District",
        "districtPlaceholder": "Select district",
        "streamCategory": "Stream Category",
        "streamCategoryPlaceholder": "Select your stream category",
        "optional": "optional",
        "submit": "Continue",
        "setPassword": "Set Your Password",
        "password": "Password",
        "confirmPassword": "Confirm Password",
        "passwordPlaceholder": "At least 6 characters",
        "confirmPasswordPlaceholder": "Re-enter your password",
        "error": {
            "required": "Please fill in all required fields",
            "generic": "An error occurred, please try again",
            "passwordMin": "Password must be at least 6 characters",
            "passwordMismatch": "Passwords do not match",
            "under18": "Users must be at least 18 years old",
            "invalidEmail": "Please enter a valid email address"
        },
        "user": {
            "attr": {
                "livestreams": {
                    "timing": {
                        "starttime": "Start Time",
                        "durationseconds": "Duration"
                    },
                    "performance": {
                        "label": "Performance",
                        "viewers": "Viewers",
                        "peak": "Peak",
                        "impressions": "Impressions"
                    },
                    "engagement": {
                        "label": "Engagement",
                        "followers": "Followers",
                        "gifts": "Gifts",
                        "senders": "Senders"
                    },
                    "revenue": {
                        "diamonds": "Revenue (Diamonds)"
                    },
                    "features": {
                        "label": "Features"
                    }
                }
            }
        }
    },
    "interactions": {
        "title": "Creator Notes",
        "loading": "Loading...",
        "empty": "No interaction records found.",
        "type": {
            "call": "Call",
            "note": "Note",
            "message": "Message",
            "meeting": "Meeting",
            "system": "System"
        },
        "outcome": {
            "answered": "Answered",
            "noAnswer": "No Answer",
            "busy": "Busy",
            "leftVoicemail": "Left Voicemail",
            "callbackScheduled": "Callback Scheduled"
        },
        "actions": {
            "create": "Add New Note",
            "edit": "Edit",
            "delete": "Delete",
            "pin": "Pin",
            "unpin": "Unpin"
        },
        "section": {
            "recent": "Recent Notes"
        },
        "confirm": {
            "delete": "Are you sure you want to delete this interaction?"
        },
        "drawer": {
            "createTitle": "New Note",
            "editTitle": "Edit Note",
            "description": "Add a note, call, meeting, or message record about the creator."
        },
        "form": {
            "type": "Type",
            "outcome": "Outcome",
            "selectOutcome": "Select outcome",
            "content": "Content",
            "contentPlaceholder": "Write interaction details...",
            "attachments": "Attachments",
            "addFile": "Add File",
            "uploading": "Uploading...",
            "pinned": "Mark as pinned",
            "cancel": "Cancel",
            "create": "Create",
            "update": "Update",
            "saving": "Saving..."
        },
        "validation": {
            "contentRequired": "Content field is required.",
            "outcomeRequired": "Outcome is required for call type.",
            "maxAttachments": "Maximum 10 files can be attached."
        },
        "toast": {
            "created": "Interaction created successfully.",
            "updated": "Interaction updated successfully.",
            "deleted": "Interaction deleted successfully.",
            "pinned": "Interaction pinned.",
            "unpinned": "Interaction unpinned.",
            "loadError": "Failed to load interactions.",
            "saveError": "Failed to save interaction.",
            "updateError": "Failed to update interaction.",
            "deleteError": "Failed to delete interaction.",
            "uploadError": "Failed to upload file."
        }
    },
    "user": {
        "status": {
            "active": "Active",
            "suspended": "Suspended",
            "banned": "Banned",
            "account_closed": "Account Closed",
            "quit": "Quit",
            "modal": {
                "title": "Change User Status",
                "currentStatus": "Current Status",
                "newStatus": "New Status",
                "reason": "Reason",
                "reasonPlaceholder": "Write the reason for status change...",
                "cancel": "Cancel",
                "confirm": "Confirm",
                "saving": "Saving..."
            },
            "validation": {
                "reasonRequired": "Reason field is required.",
                "sameStatus": "New status cannot be the same as current status."
            },
            "toast": {
                "changed": "User status updated successfully.",
                "changeError": "Failed to change status."
            }
        }
    },
    "quickInfo": {
        "phone": "Phone",
        "lastLogin": "Last Login",
        "ipAddress": "IP Address",
        "lastBroadcast": "Last Broadcast",
        "banStatus": "Ban Status",
        "banned": "Banned",
        "active": "Active",
        "banEnd": "Ends"
    },
    "eligibility": {
        "mobile": { "today": "Today", "yesterday": "Yesterday", "okCount": "{n} eligible", "badCount": "{n} not eligible", "records": "{n} records", "loadMore": "Load more", "checkN": "Check {n} accounts" },
        "title": "Eligibility Check",
        "description": "Check if creators are eligible to join the agency",
        "usernamesLabel": "Usernames",
        "placeholder": "Enter usernames separated by commas or newlines...\ne.g.: baran.buyuk, other_user",
        "hint": "You can enter up to 30 usernames separated by commas or newlines. Results are checked via TikTok Backstage.",
        "check": "Check",
        "history": "History",
        "historyDate": "Date",
        "historyEmpty": "No checks have been made yet.",
        "newCheck": "New Check",
        "available": "Available",
        "unavailable": "Unavailable",
        "error": "An error occurred during the check.",
        "checkComplete": "{count} creator(s) checked.",
        "table": {
            "username": "Username",
            "status": "Status",
            "nickname": "Name",
            "reason": "Reason",
            "tier": "Invitation Type",
            "source": "Source",
            "queriedBy": "Queried By"
        },
        "source": {
            "ELIGIBILITY_CHECK": "Eligibility Check",
            "REFERRAL_VALIDATION": "Referral Request"
        },
        "watchlist": {
            "tab": {
                "title": "Watchlist"
            },
            "add": {
                "title": "Add User",
                "username": "Username",
                "phoneNumber": "Phone number",
                "button": "+ Add",
                "success": "User added to watchlist",
                "duplicate": "This user is already in the list"
            },
            "table": {
                "username": "Username",
                "phoneNumber": "Phone",
                "status": "Status",
                "reason": "Reason",
                "lastChecked": "Last Checked",
                "statusChanged": "Status Changed",
                "addedBy": "Added By",
                "actions": "Actions"
            },
            "summary": {
                "total": "watching",
                "available": "available",
                "unavailable": "unavailable",
                "pending": "pending"
            },
            "checkNow": {
                "label": "Check Now",
                "progress": "{checked}/{total} checked",
                "success": "Check completed",
                "error": "Check failed",
                "cooldown": "Please wait 5 minutes"
            },
            "remove": {
                "confirm": "Are you sure?"
            },
            "empty": {
                "title": "Watchlist Empty",
                "description": "No one is being watched yet. Add the first user."
            },
            "error": {
                "loadFailed": "Failed to load list. Try again."
            }
        }
    },
    "earningsDistribution": {
        "view": {
            "title": "Earnings Distribution",
            "selectMonth": "Select Month",
            "totalEarnings": "Total Earnings",
            "totalCreators": "Total Creators",
            "projected": "Projected",
            "confirmed": "Confirmed",
            "credited": "Credited"
        },
        "table": {
            "column": {
                "creator": "Creator",
                "total": "Total",
                "status": "Status",
                "type": "Earning Type",
                "amount": "Amount",
                "days": "Days",
                "hours": "Hours",
                "agencyShare": "Agency Share",
                "creatorShare": "Creator Share",
                "diamonds": "Diamonds"
            }
        },
        "action": {
            "confirm": "Confirm",
            "credit": "Credit to Wallet",
            "selectAll": "Select All",
            "editAmount": "Edit Amount"
        },
        "dialog": {
            "confirmTitle": "Confirm Earnings",
            "confirmMessage": "Earnings of {count} creator(s) will be confirmed.",
            "creditTitle": "Credit to Wallet",
            "creditMessage": "{count} creator(s) will be credited a total of {amount}. Do you confirm?"
        },
        "toast": {
            "confirmSuccess": "Earnings confirmed successfully.",
            "creditSuccess": "Earnings credited to wallets successfully.",
            "updateSuccess": "Amount updated.",
            "fetchError": "Couldn't load earnings",
            "updateError": "Couldn't update earnings",
            "confirmError": "Couldn't confirm earnings",
            "creditError": "Couldn't credit earnings to wallets"
        },
        "earningType": {
            "ACTIVENESS": "Activeness",
            "COMMISSION": "Commission",
            "INCREMENTAL_REVENUE": "Incremental Revenue",
            "RANK_BONUS": "Rank Bonus",
            "ROOKIE_MILESTONE": "Rookie Milestone",
            "REFERRAL": "Referral Commission"
        },
        "noData": "No earnings data found for the selected month.",
        "filter": {
            "all": "All",
            "byStatus": "By Status",
            "byType": "By Earning Type"
        }
    },
    "referrals": {
        "title": "Referrals",
        "table": {
            "column": {
                "referredUsername": "Referred User",
                "status": "Status",
                "activatedAt": "Activated At",
                "totalEarnings": "Total Earnings",
                "createdAt": "Created At"
            }
        },
        "status": {
            "PENDING": "Pending",
            "ACTIVE": "Active",
            "EXPIRED": "Expired",
            "CANCELLED": "Cancelled"
        },
        "noData": "No referral records found for this user.",
        "cancel": "Cancel",
        "cancelConfirm": "Are you sure you want to cancel this referral?",
        "cancelSuccess": "Referral cancelled successfully.",
        "tab": "Referrals"
    },
    "birthday": {
        "toast": {
            "title": "Happy Birthday!",
            "message": "{diamonds} diamonds have been added to your account!"
        }
    },
    "managerMapping": {
        "view": {
            "label": {
                "title": "Manager Mapping",
                "desc": "Map system manager users to their TikTok manager email addresses."
            },
            "toast": { "mapSuccess": "Manager linked", "unmapSuccess": "Manager unlinked" }
        },
        "tab": {
            "mapped": "Mapped",
            "unmapped": "Unmapped Managers",
            "orphan": "Orphan TikTok Emails"
        },
        "label": {
            "manager": "Manager",
            "tiktokManagerEmail": "TikTok Manager Email",
            "mappedAt": "Mapped At",
            "mappedBy": "Mapped By",
            "creatorCount": "{count} creators",
            "selectTiktokEmail": "Select TikTok email",
            "noMapped": "No mappings yet.",
            "noUnmapped": "No unmapped managers.",
            "noOrphan": "No orphan TikTok emails.",
            "orphanWarning": "No manager user exists for this email. Create the manager user first."
        },
        "action": {
            "unmap": "Unmap",
            "mapNow": "Map",
            "unmapConfirmText": "Are you sure you want to remove this mapping?"
        },
        "toast": {
            "mapSuccess": "Mapping created successfully.",
            "unmapSuccess": "Mapping removed successfully."
        }
    },
    "goals": {
        "template": {
            "view": {
                "title": "Goal Templates",
                "desc": "Manage monthly, quarterly and yearly goal templates",
                "create": "New Template",
                "empty": "No templates yet",
                "deleteTitle": "Delete Template",
                "deleteConfirm": "Are you sure you want to permanently delete this template?",
                "deleteSuccess": "Template deleted",
                "manageAssignments": "Manage assignments"
            },
            "label": {
                "code": "Code",
                "name": "Name",
                "description": "Description",
                "audience": "Audience",
                "metric": "Metric",
                "period": "Period",
                "targetValue": "Target Value",
                "active": "Active",
                "activeDesc": "When active, instances are generated for each period",
                "startDate": "Start Date",
                "endDate": "End Date",
                "spelExpression": "SpEL Expression",
                "targetingType": "Targeting Type",
                "segmentCode": "Segment Code",
                "assignments": "Assignments"
            },
            "audience": {
                "MANAGER": "Manager",
                "CREATOR": "Creator"
            },
            "metric": {
                "NEW_BROADCASTER_COUNT": "New Broadcaster Count",
                "SUBORDINATE_LIVE_HOURS": "Team Live Hours",
                "SUBORDINATE_DIAMOND_SUM": "Team Diamond Sum",
                "CREATOR_DIAMOND_SUM": "Creator Diamonds",
                "CREATOR_LIVE_HOURS": "Creator Live Hours",
                "CUSTOM_SPEL": "Custom SpEL"
            },
            "period": {
                "MONTHLY": "Monthly",
                "QUARTERLY": "Quarterly",
                "YEARLY": "Yearly"
            },
            "targeting": {
                "ALL": "All",
                "SEGMENT": "Segment",
                "MANUAL": "Manual"
            },
            "drawer": {
                "createTitle": "New Template",
                "editTitle": "Edit Template",
                "desc": "Configure the goal template",
                "basicInfo": "Basic Info",
                "metricConfig": "Metric Configuration",
                "periodTarget": "Period & Target",
                "targeting": "Targeting",
                "monthlyDistribution": "Monthly Distribution",
                "monthlyDistributionDesc": "12 months must sum to 1.0. Leave empty for equal distribution.",
                "sum": "Sum",
                "spelRequired": "SpEL expression is required for CUSTOM_SPEL",
                "segmentRequired": "Segment code is required for SEGMENT targeting",
                "createSuccess": "Template created",
                "updateSuccess": "Template updated",
                "distributionSumError": "Monthly shares must add up to 1. They currently add up to {sum}."
            }
        },
        "instance": {
            "view": {
                "title": "My Goals",
                "subtitle": "Your goals for this period with end-of-period projections",
                "currentPeriod": "Current Period",
                "history": "History",
                "empty": "No goals for this period."
            },
            "label": {
                "progress": "Progress",
                "dayPct": "Day %",
                "projection": "Projected end-of-period",
                "expectedPct": "Expected by today: {pct}%",
                "template": "Template",
                "period": "Period",
                "status": "Status"
            },
            "status": {
                "ACTIVE": "Active",
                "COMPLETED": "Completed",
                "MISSED": "Missed",
                "EXPIRED": "Expired"
            }
        },
        "assignment": {
            "label": {
                "assigneeType": "Assignee Type",
                "user": "User",
                "segment": "Segment",
                "override": "Target Override",
                "baseTarget": "Template Target",
                "baseTargetSource": "From template target",
                "effectiveTarget": "Effective Target",
                "active": "Active",
                "startDate": "Start Date",
                "endDate": "End Date",
                "selected": "Selected",
                "overridden": "Custom target"
            },
            "assigneeType": {
                "ALL": "All",
                "USER": "User",
                "SEGMENT": "Segment"
            },
            "drawer": {
                "title": "Assignments — {name}",
                "desc": "Assign this template to users, segments, or everyone",
                "addNew": "Add Assignment",
                "existing": "Existing Assignments",
                "empty": "No assignments yet. Add one above.",
                "emptyTitle": "No assignments yet",
                "emptyDesc": "This template has not been assigned to anyone. Start by assigning it to specific users, segments, or the entire audience.",
                "firstCTA": "Create the first assignment",
                "allHint": "This template will be assigned automatically to every {role} user.",
                "activeHint": "Instances are not generated for inactive assignments",
                "add": "Assign",
                "searchUser": "Search user…",
                "overridePlaceholder": "Leave empty to use the template target",
                "selectAssignee": "Please select an assignment target",
                "invalidOverride": "Invalid target value",
                "noTemplate": "Template not found",
                "createSuccess": "Assignment created",
                "deleteSuccess": "Assignment deleted",
                "deleteTitle": "Delete Assignment",
                "deleteConfirm": "Are you sure you want to delete this assignment?"
            }
        },
        "managerGoals": {
            "view": {
                "title": "Manager Goals",
                "subtitle": "Current-period progress across all managers",
                "empty": "No active managers in the system.",
                "noGoals": "No active goals"
            },
            "label": {
                "newTarget": "New target value",
                "invalidTarget": "Please enter a valid positive target.",
                "overrideSuccess": "Target updated and recomputed.",
                "recomputeSuccess": "Recomputed.",
                "manager": "Manager",
                "goalCount": "Goal Count",
                "goals": "goals",
                "onTrack": "on track"
            },
            "action": {
                "override": "Override target",
                "recompute": "Recompute"
            },
            "override": {
                "title": "Override Target Value"
            }
        }
    },
    "report": {
        "list": {
            "title": "Reports",
            "subtitle": "Open any report you have access to from here.",
            "empty": "No reports available.",
            "loadFailed": "Failed to load reports"
        },
        "runner": {
            "title": "Run Report",
            "subtitle": "Pick filters and run the report.",
            "run": "Run",
            "running": "Running…",
            "exportCsv": "Download CSV",
            "exporting": "Downloading…",
            "exportFailed": "Export failed",
            "runFailed": "Report run failed",
            "schemaFailed": "Failed to load report schema",
            "noResults": "No records match the filters.",
            "dateRangeStart": "Start date",
            "dateRangeEnd": "End date"
        },
        "wallet-transactions": {
            "name": "Creator Wallet Transactions",
            "desc": "Lists wallet movements (earnings, withdrawals, support diamonds, …) for creators.",
            "param": {
                "dateRange": "Date Range",
                "managerIds": "Manager",
                "types": "Transaction Types"
            },
            "column": {
                "username": "Creator",
                "managerName": "Manager",
                "type": "Type",
                "amount": "Amount",
                "balanceAfter": "Balance After",
                "description": "Description",
                "createdAt": "Date"
            }
        },
        "equipment-assignments": {
            "name": "Creator Equipment Report",
            "desc": "Lists equipment given to creators, quantities, and assign/return dates.",
            "param": {
                "dateRange": "Assigned Date",
                "equipmentIds": "Equipment",
                "managerIds": "Manager",
                "status": {
                    "option": {
                        "ACTIVE": "Active",
                        "RETURNED": "Returned",
                        "ALL": "All"
                    }
                }
            },
            "column": {
                "username": "Creator",
                "managerName": "Manager",
                "equipmentName": "Equipment",
                "assignedQuantity": "Assigned",
                "returnedQuantity": "Returned",
                "assignedAt": "Assigned",
                "returnedAt": "Returned",
                "notes": "Notes"
            }
        },
        "creator-interactions": {
            "name": "Creator Notes & Interactions",
            "desc": "Lists notes, messages, calls and meetings logged for creators.",
            "param": {
                "dateRange": "Date Range",
                "managerIds": "Manager",
                "types": "Types"
            },
            "column": {
                "username": "Creator",
                "managerName": "Manager",
                "type": "Type",
                "content": "Content",
                "outcome": "Outcome",
                "createdByName": "Added By",
                "createdAt": "Date"
            }
        },
        "preset": {
            "all": "All",
            "today": "Today",
            "last7": "Last 7 days",
            "last30": "Last 30 days",
            "thisMonth": "This month",
            "custom": "Custom Range"
        }
    },
    "creatorLead": {
        "tabs": {
            "official": "TikTok Official Leads",
            "found": "Discovered Creator Leads",
            "outreach": "Outreach",
            "applications": "Website Applications"
        },
        "scout": {
            "hasContactFilter": "Has contact info",
            "title": "Scout Leads",
            "lastSync": "Last sync",
            "searchPlaceholder": "Search username…",
            "empty": "No leads in this stage. Data syncs from TikTok Backstage every 6 hours.",
            "unavailable": "Account unavailable",
            "stage": {
                "1": "To review",
                "2": "Contacted",
                "3": "Invited",
                "4": "Not interested"
            },
            "sort": {
                "liveTimes": "By live days",
                "diamonds": "By diamonds",
                "followers": "By followers",
                "lastSeen": "By last seen",
                "newest": "Newest"
            },
            "table": {
                "contact": "Contact",
                "phone": "Phone",
                "avgWatch": "Avg viewers (30d)",
                "liveDuration30d": "Live duration (30d)",
                "liveTimes30d": "Live days (30d)",
                "diamonds30d": "Diamonds (30d)",
                "creator": "Creator",
                "followers": "Followers",
                "likes": "Likes",
                "videos": "Videos",
                "addedAt": "Added to pool",
                "invitedAt": "Invited at",
                "expiresAt": "Expires",
                "flags": "Status"
            },
            "flag": {
                "joined": "Joined agency",
                "applied": "Applied",
                "marked": "Marked"
            }
        },
        "view": {
            "title": "Creator Leads",
            "subtitle": "Upload broadcasters via CSV, track eligibility, enrich profiles before outreach."
        },
        "upload": {
            "title": "Drop or click to upload a CSV",
            "hint": "Columns: username (or farmos format: userId, uniqueId, league, rank, score)",
            "button": "Upload CSV",
            "uploading": "Uploading…",
            "inserted": "Inserted",
            "updated": "Updated",
            "skipped": "Skipped",
            "errors": "Errors",
            "total": "Total"
        },
        "filter": {
            "searchPlaceholder": "Search by username or nickname…",
            "allStatus": "All statuses",
            "allTier": "All tiers",
            "allManagers": "All managers",
            "unassigned": "Unassigned",
            "allLeagues": "All leagues",
            "allMessageStatus": "All message statuses",
            "pastLiveCountPlaceholder": "Min. Live count",
            "totalLiveLikesPlaceholder": "Min. Total live likes",
            "avgDurationPlaceholder": "Min. Avg live duration",
            "clearAll": "Clear filters",
            "clearAllTitle": "Reset all filters and sorting",
            "addFilter": "Add filter",
            "removeFilter": "Remove filter",
            "clearOne": "Clear",
            "noneApplied": "All",
            "noFilterMatches": "No matching filter",
            "unassignedDescription": "Leads without an assigned manager",
            "watchlisted": "On Watchlist",
            "watchlistedDescription": "Only leads on the watchlist",
            "aiAnalyzed": "AI Analyzed",
            "aiAnalyzedDescription": "Leads previously run through AI analysis",
            "messaged": "Messaged",
            "messagedDescription": "Leads a send was attempted for (reached or not)",
            "activeCount": "{count} Filter",
            "totalResults": "{count} results",
            "commandHint": "Name, nick, manager… or try 'league:premier 10M+'",
            "searchPlain": "Search by username or nick…",
            "group": {
                "creator": "Creator",
                "performance": "Performance",
                "communication": "Communication",
                "view": "View"
            },
            "sort": "Sort",
            "preset": {
                "invitable": "Invitable"
            },
            "pastLiveCount": {
                "all": "All live counts"
            },
            "totalLiveLikes": {
                "all": "All like ranges",
                "10k": "10K+",
                "100k": "100K+",
                "1m": "1M+",
                "10m": "10M+",
                "100m": "100M+"
            },
            "avgDuration": {
                "all": "All duration ranges",
                "30m": "30 min+",
                "1h": "1 hour+",
                "2h": "2 hours+",
                "4h": "4 hours+",
                "6h": "6 hours+"
            }
        },
        "sort": {
            "label": "Sort by",
            "newest": "Newest first",
            "oldest": "Oldest first",
            "followerDesc": "Followers (high)",
            "rankAsc": "League rank (1→N)",
            "scoreDesc": "Score (high)"
        },
        "action": {
            "assign": "Assign manager",
            "unassign": "Unassign"
        },
        "table": {
            "username": "Creator",
            "reason": "Sub-reason",
            "status": "Status",
            "tier": "Invitation Type",
            "followers": "Followers",
            "likes": "Likes",
            "videos": "Videos",
            "league": "League",
            "rank": "Rank",
            "score": "Score",
            "manager": "Manager",
            "messageStatus": "Message status",
            "pastLiveCount": "Live Stream Count",
            "totalLiveLikes": "Live Stream Likes",
            "avgDuration": "Average Live Duration",
            "fansClub": "Fan club",
            "lastLive": "Last live",
            "lastChecked": "Last Eligibility Check",
            "imported": "Imported",
            "source": "Source",
            "potential": "Potential",
            "potentialTooltip": "Revenue potential (0-100) based on league, eligibility and live activity.",
            "watchlisted": "Watchlist",
            "watchlistedTooltip": "Lead is on the watchlist",
            "aiAnalyzed": "AI",
            "aiAnalyzedTooltip": "Lead has been analyzed by AI",
            "messaged": "Msg",
            "messagedTooltip": "A send was attempted — see message status for the result",
            "empty": "No leads yet."
        },
        "messageStatus": {
            "NOT_CONTACTED": "Not contacted",
            "QUEUED": "Queued",
            "SENT": "Sent",
            "REPLIED": "Replied",
            "CONVERTED": "Converted",
            "OPTED_OUT": "Opted out",
            "BOUNCED": "Bounced (retry)",
            "DM_CLOSED": "DMs closed",
            "UNREACHABLE": "Unreachable",
            "OWNED_BY_OTHER_MANAGER": "Owned by another manager"
        },
        "sendOutcome": {
            "SENT_REQUEST": "Request sent",
            "DELIVERED": "Delivered",
            "SENT": "Sent",
            "BOUND_OTHER_AGENT": "Owned by another manager",
            "BOUND_OTHER_AGENCY": "Other agency",
            "BANNED": "Banned",
            "NOT_QUALIFIED": "Not qualified",
            "NOT_ELIGIBLE": "Not eligible",
            "GATE_UNVERIFIED": "Unverified (retry)",
            "RECEIVER_CLOSED": "DMs closed",
            "USER_NOT_FOUND": "Not found",
            "SEND_REJECTED": "Rejected",
            "ENGINE_ERROR": "Send error"
        },
        "reason": {
            "AVAILABLE": "Eligible",
            "NOT_FOUND": "Not found",
            "REGION_MISMATCH": "Unsupported region",
            "INELIGIBLE": "Ineligible",
            "NOT_ACCESS_LIVE": "No LIVE access",
            "UNAVAILABLE": "Unavailable",
            "INVITATIONTYPE_NOT_AVAILABLE": "Invitation type unavailable",
            "QUOTA_LIMIT": "Invitation quota full",
            "UNKNOWN": "Unspecified",
            "FOLLOWERS_TOO_MUCH": "Over follower limit",
            "ALREADY_SIGNED": "In another agency",
            "OTHER_REASONS": "Other reasons",
            "DECLINED_BY_SUMA": "Multiple account risk",
            "DECLINED_BY_LOCATION": "Unsupported region",
            "DECLINED_BY_CONTENT": "Inappropriate content",
            "DECLINED_BY_HISTORY": "Insufficient content history",
            "DECLINED_BY_BRIC": "Multiple account risk",
            "IN_INVITE_PROCESS": "Invitation in progress",
            "CONTENT_VIOLATION": "LIVE content violates Community Guidelines",
            "IDENTITY_INELIGIBLE": "Does not meet identity requirements",
            "LIVE_DATA_NOT_MEET_REQUIREMENT": "LIVE data does not meet invitation requirements",
            "JOIN_QUALIFICATION_FROZEN": "Invitation qualification frozen",
            "ACCOUNT_PERFORMANCE_QUALIFY_FAILED": "Does not meet safety requirements"
        },
        "status": {
            "UNCHECKED": "Pending",
            "ELIGIBLE": "Eligible",
            "NEEDS_TRIAL": "Needs trial",
            "INVITED_PENDING": "Pending invitation",
            "IN_OTHER_AGENCY": "In other agency",
            "INVITE_DISABLED": "Invite disabled",
            "MULTI_ACCOUNT": "Multi-account mismatch",
            "NOT_FOUND": "Not found",
            "OTHER": "Other",
            "ERROR": "Error"
        },
        "tier": {
            "NORMAL": "Classic",
            "ELITE": "Premium (legacy)",
            "SUPER_ELITE": "Regular",
            "EXCLUSIVE": "Elite",
            "PREMIUM": "High-follower",
            "CUSTOM": "Premium"
        },
        "pagination": {
            "summary": "{from}-{to} of {total}"
        },
        "toast": {
            "uploadOk": "{inserted} inserted, {updated} updated, {skipped} skipped.",
            "uploadError": "Upload failed.",
            "loadError": "Could not load list.",
            "notCsv": "Only .csv files are supported.",
            "assignOk": "{'@'}{username} → {manager}",
            "unassignOk": "{'@'}{username} unassigned.",
            "assignError": "Assignment failed.",
            "messageStatusOk": "Message status updated: {status}"
        },
        "savedViews": {
            "add": "View",
            "addTitle": "Save current filter combination",
            "savePromptName": "View name:",
            "saved": "View {name} saved.",
            "deleteConfirm": "Delete view {name}?",
            "unsaved": "Unsaved changes"
        },
        "bulk": {
            "button": {
                "send": "Send Bulk Message"
            },
            "drawer": {
                "title": "Send Message to Selected Leads",
                "subtitle": "{count} creators selected. Use the default message or write a personal one."
            },
            "defaultText": {
                "label": "Default Message",
                "placeholder": "Hi, how are you",
                "hint": "Lines left blank will receive this text."
            },
            "customText": {
                "placeholder": "Customize for this creator (blank: \"{default}\")"
            },
            "noManager": "No manager assigned — these leads will be skipped",
            "noFlowMapping": "No TikTok account mapping for this manager — will be skipped",
            "account": {
                "label": "Sender account",
                "hint": "Messages are sent from the TikTok account you pick; the lead sees them from that account.",
                "default": "Default agency account",
                "needsLogin": "login required",
                "notReady": "This account's session isn't verified yet. The first send may require login/verification."
            },
            "gate": {
                "sendable": "{count} eligible — will send",
                "blocked": "{count} blocked",
                "blockedHead": "{count} leads blocked — eligibility is re-checked at send time"
            },
            "send": {
                "button": "Send to {count}",
                "summary": "{valid} valid / {total} selected",
                "startedToast": "Send started. {count} queued, {skipped} skipped. Results will show on lead status.",
                "preCheckRunning": "Checking eligibility...",
                "removedLeads": "{count} leads removed from list — eligibility changed"
            },
            "eligibility": {
                "button": "Bulk Eligibility Check",
                "modal": {
                    "title": "Bulk Eligibility Check",
                    "checking": "Checking...",
                    "summary": "{total} leads checked",
                    "eligible": "Eligible",
                    "ineligible": "Ineligible",
                    "changed": "{count} leads' status changed"
                }
            },
            "noSelection": "Select at least one creator first.",
            "selectedSuffix": "selected",
            "overLimit": "At most {max} records can be selected for this action.",
            "clearSelection": "Clear Selection",
            "cancelSelection": "Cancel Selection",
            "selectPage": "Select Page",
            "unselectPage": "Unselect Page"
        },
        "messaging": {
            "title": "Message Candidates",
            "subtitle": "Bulk-message candidates from your chosen TikTok account — eligibility is re-checked before every message.",
            "soon": "This section arrives in the next step.",
            "continue": "Continue",
            "agent": {
                "roleOfficial": "Official",
                "roleManager": "Manager"
            },
            "allBlocked": "All selected candidates are closed to re-sending (other agency / not qualified / DMs closed).",
            "someBlocked": "{blocked} candidate(s) closed to re-sending were skipped. Continuing with {eligible}.",
            "template": {
                "label": "Message template",
                "none": "Select template…",
                "new": "New",
                "edit": "Edit template",
                "delete": "Delete template",
                "namePh": "Template name (e.g. Lexa Invite – Short)",
                "bodyPh": "Message text…",
                "required": "Template name and text are required.",
                "saved": "Template saved.",
                "deleted": "Template deleted."
            },
            "account": {
                "sender": "sender account",
                "change": "Change",
                "lede": "Which account will you send from?",
                "hint": "Messages are sent from your chosen account's TikTok identity; the lead sees them from that account.",
                "defaultDesc": "The agency's primary scrape account",
                "ready": "Session ready",
                "needsLogin": "Login required",
                "newLogin": "Sign in with a new account",
                "pickFirst": "Pick an account first.",
                "relogin": "Re-login",
                "emailPh": "name{'@'}haymen.com.tr",
                "passwordPh": "TikTok password",
                "loginBtn": "Sign in",
                "loggingIn": "Signing in…",
                "loginHint": "The first login may require TikTok device verification. The password is stored encrypted and never shown.",
                "formRequired": "Email and password are required.",
                "loginOk": "Signed in — account ready.",
                "loginFail": "Sign-in failed — check the details and try again.",
                "pool": "Eligibility pool",
                "poolHint": "Eligibility checks (panel checks and the pre-send gate of outreach messages) are spread round-robin across the accounts in the pool; an account that hits a risk gate sits out for a while. If none is selected, checks run from the default/sender account as before.",
                "poolOn": "In pool",
                "poolNeedsLogin": "The account's session must be ready to join the pool.",
                "poolAdded": "Account added to the eligibility pool.",
                "poolRemoved": "Account removed from the eligibility pool.",
                "twoFactor": {
                    "title": "Two-step verification",
                    "pickLede": "TikTok wants a verification code for this account. Choose where to send it.",
                    "sms": "Code by SMS",
                    "email": "Code by email",
                    "sending": "Sending the code…",
                    "codeLede": "Enter the code sent to {target}. It is valid for a few minutes.",
                    "codeLedeGeneric": "Enter the verification code TikTok sent.",
                    "codePh": "Verification code",
                    "confirm": "Verify",
                    "verifying": "Verifying…",
                    "resend": "No code? Use another method or resend",
                    "codeRequired": "Enter the code you received."
                },
                "errors": {
                    "bad_credentials": "TikTok rejected the email or password (account not found or wrong password).",
                    "two_factor_code_rejected": "The code was not accepted. Check it and try again.",
                    "two_factor_expired": "Verification timed out. Log in again.",
                    "two_factor_required": "TikTok wants a verification code. Log in again from the panel.",
                    "login_cooldown": "Too many failed attempts. Try again a little later.",
                    "timeout": "TikTok did not respond in time. Try again."
                }
            },
            "step": {
                "account": "Account",
                "leads": "My candidates",
                "send": "Eligibility & send",
                "inbox": "Inbox"
            },
            "leads": {
                "onlyMine": "Only assigned to me",
                "count": "{n} candidates",
                "selectAll": "Select all",
                "clearAll": "Clear selection",
                "selected": "{n} selected",
                "next": "Eligibility & send",
                "empty": "No messageable assigned candidates.",
                "colCandidate": "Candidate",
                "colFollowers": "Followers",
                "colLives": "Lives",
                "colPotential": "Potential",
                "colEligibility": "Eligibility",
                "colTier": "Tier",
                "colMsgStatus": "Message status",
                "total": "{n} candidates",
                "search": "Search candidates (username / nickname)",
                "selectPage": "Select page",
                "loadMore": "Load more"
            },
            "gate": {
                "warn": "Messaging a creator bound to another agency is a poaching violation. Eligibility is re-checked against TikTok at send time for every candidate; unverifiable ones are not sent.",
                "selected": "Selected",
                "sendable": "Eligible — will send",
                "blocked": "Blocked",
                "blockedHead": "{n} candidates blocked",
                "pace": "A 4–8s pause is applied between messages.",
                "progress": "{done}/{total} candidates checked",
                "retry": "Retry",
                "notStarted": "Eligibility check has not started.",
                "send": "Send to {n} eligible"
            },
            "inbox": {
                "title": "Inbox",
                "sent": "Send started. Replies will land here; for now track them on the candidate status.",
                "more": "New send",
                "refresh": "Refresh",
                "empty": "No conversations yet.",
                "noMessages": "No messages in this conversation.",
                "pick": "Pick a conversation on the left.",
                "replyPh": "Write a reply…",
                "reply": "Send",
                "sending": "Sending…",
                "replySent": "Reply sent.",
                "replyBlocked": "Not sent: {reason}",
                "replyFail": "Reply could not be sent.",
                "loadFail": "Inbox could not load (session/reads to be tuned live).",
                "agentLede": "Whose inbox do you want to view?",
                "pickAgentFirst": "Select the account whose inbox to view."
            },
            "sender": { "title": "Which account should send?", "desc": "Messages go out under the agency account you pick. Choose one and we'll check candidate eligibility for it.", "pickFirst": "Pick a sender account to check candidate eligibility." }
        },
        "ai": {
            "button": {
                "analyze": "Analyze with AI"
            },
            "modal": {
                "title": "AI Lead Analysis",
                "analyzing": "Running AI analysis...",
                "summary": "{total} leads analyzed",
                "remaining": "Analyses remaining today: {count}",
                "remainingLabel": "Quota Left",
                "subtitleSetup": "Pick the best from the pool",
                "subtitleAnalyzing": "Evaluating {count} leads with AI",
                "subtitleDone": "Top {count} leads selected",
                "leadsInflight": "{count} leads in flight",
                "empty": "No analysis results."
            },
            "setup": {
                "title": "AI Lead Selection",
                "desc": "Build a pool of the highest-potential leads and let AI pick the best.",
                "poolSize": "Pool Size",
                "poolHint": "Number of leads sent to AI. Larger pool = better picks, slower/costlier.",
                "topK": "Top K",
                "topKHint": "How many leads AI should recommend from the pool.",
                "summary": "Pick top {top} from {pool} leads",
                "start": "Start Analysis",
                "topKTooLarge": "Top-K cannot exceed pool size."
            },
            "phase": {
                "gather": "Gathering live and engagement signals",
                "cross": "Cross-referencing league and eligibility",
                "score": "Estimating potential score",
                "rank": "Ranking results"
            },
            "history": {
                "title": "AI Analysis History",
                "subtitle": "Browse your past AI analyses.",
                "empty": "No AI analyses yet.",
                "col": {
                    "createdAt": "Started",
                    "initiatedBy": "Initiated By",
                    "totalLeads": "Leads",
                    "status": "Status",
                    "finishedAt": "Finished",
                    "duration": "Duration"
                },
                "status": {
                    "QUEUED": "Queued",
                    "RUNNING": "Running",
                    "COMPLETED": "Completed",
                    "FAILED": "Failed"
                }
            },
            "tier": {
                "HIGH": "High Potential",
                "MID": "Mid Potential",
                "LOW": "Low Potential"
            },
            "recommendation": {
                "INVITE_NOW": "Invite Now",
                "WATCH": "Watch",
                "SKIP": "Skip"
            }
        },
        "watchlist": {
            "button": {
                "add": "Add to Watchlist"
            },
            "added": "{count} lead added to the watchlist.",
            "alreadyAll": "All selected leads are already on the watchlist."
        },
        "outreachJobs": {
            "title": "Send Jobs",
            "subtitle": "Watch bulk sends live, lead by lead — status, sub-reason and time.",
            "live": "Live",
            "refresh": "Refresh",
            "empty": "No sends yet. Select leads and start with \"Message Leads\".",
            "pickOne": "Pick a job on the left.",
            "loadMore": "Load more",
            "noItems": "No leads in this filter.",
            "startedBy": "Started by {name}",
            "filter": {
                "all": "All"
            },
            "tile": {
                "total": "Total",
                "pending": "Queued",
                "sent": "Sent",
                "blocked": "Blocked",
                "failed": "Failed",
                "skipped": "Skipped"
            },
            "jobStatus": {
                "PENDING": "Pending",
                "RUNNING": "Sending",
                "COMPLETED": "Completed",
                "PARTIAL": "Partially completed",
                "FAILED": "Failed",
                "INTERRUPTED": "Interrupted"
            },
            "itemStatus": {
                "PENDING": "Queued",
                "SENT": "Sent",
                "FAILED": "Failed",
                "BLOCKED_NOT_ELIGIBLE": "Blocked",
                "SKIPPED_PRE": "Skipped"
            },
            "reason": {
                "ineligible_state": "Already in contact (state not messageable)",
                "send_blocked": "Previous send was blocked (DMs closed / unreachable)",
                "owned_by_other_manager": "Owned by another manager — only the owning account can write",
                "lead_not_found": "Lead not found",
                "missing_text": "Empty message text",
                "no_result": "Send service returned no result",
                "engine_error": "Automation service error",
                "handler_error": "Automation service error",
                "banned": "Account banned",
                "no_invite_benefit": "Bound to another agency (no invite benefit)",
                "not_eligible": "Not eligible",
                "not_found": "Not found in eligibility check",
                "eligibility_error": "Could not verify eligibility (network) — retryable",
                "eligibility_unverified": "Could not verify eligibility (session) — retryable",
                "receiver_permission_off": "Receiver has DMs closed",
                "bound_to_another_manager": "Bound to another manager",
                "not_qualified": "No agency qualification",
                "user_not_found": "User not found on TikTok",
                "not_delivered": "Rejected by TikTok"
            }
        },
        "outreachJob": {
            "view": {
                "title": "Outreach History",
                "subtitle": "Track your bulk message sends and their results."
            },
            "filter": {
                "mineOnly": "Only My Sends"
            },
            "autoRefresh": {
                "on": "Refresh On",
                "off": "Refresh Off",
                "active": "Active job in progress, auto-refresh every 5s",
                "idle": "All jobs finished, auto-refresh paused"
            },
            "column": {
                "createdAt": "Started",
                "finishedAt": "Finished",
                "initiatedBy": "Initiated By",
                "total": "Total",
                "sent": "Sent",
                "failed": "Failed",
                "skipped": "Skipped",
                "status": "Status"
            },
            "status": {
                "PENDING": "Pending",
                "RUNNING": "Running",
                "COMPLETED": "Completed",
                "PARTIAL": "Partial",
                "FAILED": "Failed",
                "INTERRUPTED": "Interrupted"
            },
            "detail": {
                "title": "Outreach Detail",
                "itemsHeader": "Creators ({count})"
            },
            "item": {
                "status": {
                    "SENT": "Sent",
                    "FAILED": "Failed",
                    "SKIPPED_PRE": "Skipped",
                    "PENDING": "Pending"
                },
                "reason": {
                    "no_manager": "No manager assigned",
                    "no_flow_mapping": "No TikTok mapping for manager",
                    "ineligible_state": "Lead no longer eligible",
                    "lead_not_found": "Record not found",
                    "missing_text": "Empty message text",
                    "missing_handle": "Empty username",
                    "engine_error": "Automation engine error",
                    "engine_timeout": "Automation engine timeout",
                    "tiktok_silent_reject": "TikTok silently rejected",
                    "receiver_permission_off": "Receiver has DMs turned off",
                    "unknown_reject": "Rejected (reason unknown)",
                    "bound_to_other_seat": "Bound to another manager",
                    "not_agency_eligible": "Not eligible for agency invite",
                    "user_not_found": "User not found on TikTok"
                }
            },
            "empty": "No bulk sends yet."
        }
    },
    "filter": {
        "addFilter": "Add filter",
        "removeFilter": "Remove filter",
        "clearAll": "Clear filters",
        "clearOne": "Clear",
        "noneApplied": "All",
        "noFilterMatches": "No matching filter",
        "searchPlaceholder": "Search filter…",
        "searchPlain": "Search…",
        "sortLabel": "Sort by",
        "activeCount": "{count} Filter",
        "totalResults": "{count} results",
        "savedViews": {
            "all": "All",
            "add": "View",
            "savePromptName": "View name:",
            "saved": "View {name} saved.",
            "deleteConfirm": "Delete view {name}?",
            "unsaved": "Unsaved changes"
        }
    },
    "scrape": {
        "trigger": {
            "view": {
                "title": "Manual Data Fetch",
                "subtitle": "Manually fetch TikTok data for a given month and an optional list of users."
            },
            "label": {
                "cycleMonth": "Cycle (Month)",
                "cycleCurrent": "Current Month",
                "usernames": "Usernames",
                "userCount": "{n} users",
                "allCreators": "All active creators",
                "months": "Backfill Depth (Months)",
                "backfillMonths": "Newest {n} cycles (backfill)",
                "summary": "Will trigger",
                "tail": "Trigger is running in the background. Track progress via backend logs."
            },
            "hint": {
                "cycleMonth": "Leave empty for the current month.",
                "usernames": "Separate by space, comma or newline. Leave empty to scrape all active creators.",
                "months": "1 = normal pull (current cycle). N>1 = one-time historical backfill: newest N settle cycles per creator.",
                "monthsDisabled": "Backfill depth is unavailable when a specific cycle is selected."
            },
            "placeholder": {
                "usernames": "ozgenizresmii\nnurhoca11\ndemettiktok"
            },
            "action": {
                "run": "Start Scrape"
            },
            "toast": {
                "accepted": "Scrape accepted: {id}",
                "acceptedTitle": "Triggered",
                "failed": "Trigger failed"
            }
        }
    },
    "tournament": {
        "view": {
            "label": {
                "title": "Tournament Management",
                "desc": "Manage TikTok LIVE Cup brackets, fixtures and round results."
            }
        },
        "list": {
            "label": {
                "title": "Tournaments",
                "bracket": "Bracket"
            }
        },
        "detail": {
            "label": {
                "empty": "Select a tournament from the left",
                "startDate": "Start",
                "rounds": "rounds",
                "participants": "participants"
            }
        },
        "tab": {
            "bracket": "Bracket",
            "schedule": "Schedule",
            "fixture": "Fixture",
            "participants": "Participants"
        },
        "status": {
            "notStarted": "Not Started",
            "inProgress": "In Progress",
            "completed": "Completed"
        },
        "matchStatus": {
            "scheduled": "Scheduled",
            "inProgress": "In Progress",
            "completed": "Completed",
            "forfeitA": "A Forfeit",
            "forfeitB": "B Forfeit",
            "doubleForfeit": "Double Forfeit"
        },
        "round": {
            "round": "Round {n}",
            "final": "FINAL",
            "semifinal": "Semifinal",
            "quarterfinal": "Quarterfinal"
        },
        "bracket": {
            "label": {
                "tbd": "TBD"
            }
        },
        "fixture": {
            "filter": {
                "allRounds": "All Rounds",
                "allStatus": "All Status"
            },
            "col": {
                "matchCode": "Match Code",
                "round": "Round",
                "date": "Date",
                "time": "Time",
                "sideA": "Side A",
                "sideB": "Side B",
                "status": "Status",
                "winner": "Winner",
                "actions": "Actions"
            },
            "action": {
                "setResult": "Set Result",
                "edit": "Edit"
            }
        },
        "participants": {
            "col": {
                "rank": "Rank",
                "tier": "Tier",
                "username": "Username",
                "name": "Display Name",
                "manager": "Manager",
                "score": "Score",
                "expected12d": "Expected Diamonds (12d)",
                "actions": "Actions"
            },
            "action": {
                "swap": "Swap Broadcaster"
            }
        },
        "schedule": {
            "title": "Schedule Parameters: {code}",
            "label": {
                "intro": "Enter these values exactly in the TikTok template settings. The system auto-calculates all round dates from these parameters.",
                "startAt": "Tournament Start Time",
                "duration": "Round Duration",
                "interval": "Interval Between Rounds",
                "preview": "Round Preview",
                "matches": "matches",
                "played": "played"
            },
            "hint": {
                "startAt": "Must match TikTok's 'Tournament start time' (Europe/Istanbul).",
                "duration": "TikTok's 'Each round in minutes' field.",
                "interval": "TikTok's 'Interval between rounds' (days/hours/minutes)."
            },
            "unit": {
                "days": "days",
                "hours": "hours",
                "minutes": "minutes"
            },
            "action": {
                "edit": "Edit",
                "save": "Save Parameters"
            },
            "toast": {
                "saved": "Parameters updated, round schedule recomputed",
                "saveError": "Failed to save parameters",
                "invalidDuration": "Round duration must be at least 1 minute"
            }
        },
        "pairing": {
            "title": "Re-pair Match: {code}",
            "label": {
                "intro": "Swap one side of this match with another broadcaster in the same bracket. Both matches update, participant count stays the same.",
                "currentMatch": "This Match",
                "swapWith": "Swap With",
                "opponent": "Opponent",
                "noCandidates": "No eligible candidates in this bracket",
                "preview": "Preview"
            },
            "placeholder": {
                "search": "Search by username or name..."
            },
            "hint": {
                "pickSide": "Which side do you want to swap?",
                "search": "{n} candidate broadcasters"
            },
            "action": {
                "openTitle": "Re-pair this match",
                "confirm": "Swap"
            },
            "toast": {
                "selectTarget": "Select a broadcaster to swap with",
                "swapped": "Pairings updated",
                "swapError": "Re-pair failed"
            }
        },
        "swap": {
            "title": "Swap Broadcaster",
            "label": {
                "current": "Current Broadcaster",
                "searchReplacement": "Search Replacement",
                "noResults": "No results",
                "sameAsCurrent": "Current"
            },
            "placeholder": {
                "search": "Username or name..."
            },
            "hint": {
                "search": "Type at least 2 characters. Only users with CREATORS role are listed."
            },
            "warning": "Only updates opponents in not-yet-played matches. Completed matches are immutable.",
            "action": {
                "confirm": "Swap"
            },
            "toast": {
                "selectUser": "Please select a broadcaster",
                "swapped": "Broadcaster swapped, related matches updated",
                "swapError": "Swap failed"
            }
        },
        "cascade": {
            "title": "Remove from System + Cascade Promote",
            "mode": {
                "auto": "Auto",
                "manual": "Manual Pick"
            },
            "label": {
                "intro": "This broadcaster is removed from all tournaments and replaced. If the incoming user is already in other tournaments, those vacancies auto-fill with the highest-ranked POOL broadcasters.",
                "introAuto": "This broadcaster is removed from all tournaments. Each vacated slot is auto-filled by the system with the highest-ranked POOL broadcaster. You don't pick.",
                "introManual": "This broadcaster is removed from all tournaments and replaced by your pick. If the incoming user is already in other tournaments, those vacancies auto-fill with the highest-ranked POOL broadcasters.",
                "previewAuto": "Auto mode: system will fill {count} slots automatically from the pool.",
                "outgoing": "Outgoing Broadcaster",
                "searchIncoming": "Search Replacement",
                "tournamentCount": "in tournaments",
                "previewWarning": "This will affect {count} slots. Completed matches are immutable.",
                "completed": "Cascade complete: {total} steps, {slots} slots affected.",
                "vacantSlot": "VACANT (pool exhausted)"
            },
            "placeholder": {
                "search": "Username or name..."
            },
            "hint": {
                "search": "Type at least 2 characters."
            },
            "action": {
                "openTitle": "Remove + cascade promote",
                "execute": "Execute",
                "replace": "Replace",
                "promote": "Cascade",
                "vacant": "Vacant"
            },
            "toast": {
                "selectUser": "Select an incoming broadcaster",
                "done": "Cascade complete ({steps} steps)",
                "error": "Cascade failed"
            }
        },
        "allParticipants": {
            "view": {
                "label": {
                    "title": "All Participants",
                    "desc": "All broadcasters across tournaments (unique). A broadcaster can be in multiple tournaments."
                }
            },
            "label": {
                "allTiers": "All Tiers",
                "uniqueBroadcasters": "Unique Broadcasters",
                "multiTournament": "In Multiple Tournaments",
                "totalEnrollments": "Total Enrollments",
                "empty": "No participants match filters."
            },
            "placeholder": {
                "search": "Search by username, name or manager..."
            },
            "col": {
                "tournaments": "Tournaments",
                "tournamentCount": "Count"
            },
            "toast": {
                "loadError": "Failed to load participants"
            }
        },
        "managerSchedule": {
            "view": {
                "label": {
                    "title": "My Match Schedule",
                    "desc": "All tournament matches for broadcasters you manage, day by day."
                }
            },
            "label": {
                "manager": "Manager Email",
                "totalMatches": "Total Matches",
                "broadcasters": "Broadcasters",
                "activeDays": "Active Days",
                "matchesShort": "matches",
                "empty": "No tournament matches for broadcasters of this manager.",
                "enterEmail": "Enter a manager email.",
                "allManagers": "All Managers",
                "vs": "VS"
            },
            "placeholder": {
                "manager": "manager@haymen.com.tr",
                "adminFilter": "All managers (type email to filter)"
            },
            "toast": {
                "loadError": "Failed to load schedule"
            }
        },
        "result": {
            "title": "Match Result: {code}",
            "label": {
                "sideA": "Side A",
                "sideB": "Side B",
                "status": "Status",
                "winner": "Winner",
                "sideADiamonds": "A Diamonds",
                "sideBDiamonds": "B Diamonds"
            },
            "hint": {
                "forfeitA": "A did not go live → B auto-advances",
                "forfeitB": "B did not go live → A auto-advances",
                "doubleForfeit": "Neither went live → both eliminated"
            },
            "action": {
                "save": "Save Result"
            },
            "toast": {
                "winnerRequired": "Winner must be selected",
                "saved": "Result saved and auto-advanced to next round",
                "saveError": "Failed to save result"
            }
        },
        "toast": {
            "loadError": "Failed to load tournament data"
        }
    },
    "guides": {
        "title": "Guide Videos",
        "hint": "The in-app \"How to use\" list. Drag to reorder; placement decides whether a video also appears on first launch or behind a screen's \"?\" button.",
        "new": "Add video",
        "edit": "Edit",
        "empty": "No guide videos yet. Start by uploading the first one.",
        "draftNote": "Draft",
        "stats": "Last 7 days: {views} views · {rate}% completion",
        "rowStats": "{views} viewers · {completed} completed",
        "chips": {
            "all": "All",
            "published": "Published",
            "draft": "Draft",
            "creators": "Creator",
            "managers": "Manager"
        },
        "columns": {
            "cover": "Cover",
            "video": "Video",
            "placement": "Placement",
            "target": "Target",
            "published": "Live"
        },
        "placement": {
            "list": "Guide",
            "onboarding": "First launch",
            "screen": "Screen: {screen}",
            "listLong": "Guide list",
            "onboardingLong": "First launch",
            "screenLong": "In-screen help",
            "hint": "Multiple allowed. \"First launch\" can be on for a single video; picking it moves it from the current one."
        },
        "roles": {
            "CREATORS": "Creator",
            "MANAGER": "Manager"
        },
        "screens": {
            "create_request": "Create request",
            "task_progress": "Task progress",
            "wallet": "Wallet",
            "violations": "Violations",
            "equipment": "Equipment request",
            "profile": "Profile",
            "inbox": "Inbox",
            "home": "Home",
            "search": "Search (manager)"
        },
        "drawer": {
            "newTitle": "Add video",
            "subtitle": "Guide Videos",
            "file": "Video file",
            "fileHint": "MP4 (H.264), portrait or landscape. Recommended limit 100 MB; duration and cover are read automatically.",
            "noFile": "No video selected yet.",
            "pick": "Choose video",
            "replace": "Replace video",
            "cover": "Upload cover",
            "uploading": "Uploading…",
            "uploaded": "Uploaded · cover taken from second 2; replace if you like.",
            "titleTr": "Title · TR",
            "titleEn": "Title · EN",
            "descTr": "Description · TR",
            "descEn": "Description · EN",
            "placement": "Placement",
            "screen": "Linked screen",
            "screenPick": "Pick a screen",
            "screenHint": "The \"?\" button at the top right of the selected screen opens this video. One video per screen.",
            "target": "Target",
            "published": "Published",
            "delete": "Delete video",
            "deleteConfirm": "Confirm delete"
        },
        "toast": {
            "loadError": "Could not load guide videos",
            "saved": "Video saved",
            "saveError": "Could not save video",
            "deleted": "Video deleted",
            "uploadError": "Upload failed",
            "hevc": "This video is HEVC (H.265). iPhone plays it, some Android devices do not; export as H.264 and re-upload if possible.",
            "faststart": "Video re-packed for mobile playback (moov moved to front).",
            "videoType": "Only MP4 files can be uploaded"
        }
    },
    "site": {
        "view": {
            "label": {
                "title": "Website",
                "description": "Manage the creator showcase on the agency website"
            }
        },
        "creators": {
            "title": "Creator showcase",
            "hint": "The creators you see here are live on the website's Creators page. Category comes from the stream category, follower counts from the daily sync; a creator without a ready image does not appear on the site.",
            "search": "Search the showcase",
            "all": "All",
            "pendingOnly": "Waiting for image",
            "column": {
                "creator": "Creator",
                "category": "Category",
                "followers": "Followers",
                "sort": "Order"
            },
            "stat": {
                "published": "Published",
                "ready": "Image ready",
                "pending": "Waiting for image · 60 per hour",
                "hidden": "Hidden (switched off)",
                "noCategory": "No category · not filterable",
                "synced": "Last follower sync"
            },
            "noCategory": "No category",
            "noCategoryShort": "No category",
            "hiddenTag": "Hidden",
            "avatarReady": "Image ready",
            "avatarPending": "Waiting for image",
            "avatarQueued": "queued",
            "avatarNextRun": "fetched on the hourly run",
            "dragHint": "Drag to reorder",
            "orderNote": "Order: numbered cards first, the rest by followers. Dropping a card gives it a number. Switched-off cards are not on the site but keep their data.",
            "order": { "label": "Order on the site", "followers": "By followers", "manual": "Manual order", "noteFollowers": "Order: most followers first. Follower counts update from TikTok automatically. Switched-off cards are not on the site but keep their data.", "toastFollowers": "The site now lists creators by followers", "toastManual": "The site now uses your manual order" },
            "empty": "No creators in the showcase yet. Add some from the agency roster.",
            "emptyFiltered": "No creators match this filter",
            "action": {
                "add": "Add creator",
                "openSite": "View on site",
                "edit": "Edit",
                "show": "Show on site",
                "hide": "Hide from site",
                "refreshAvatar": "Refresh from TikTok",
                "uploadAvatar": "Upload your own image"
            },
            "add": {
                "title": "Add creator",
                "hint": "Pick from the agency roster. The large image is fetched automatically; the creator stays off the site until it is ready.",
                "search": "Username or display name",
                "empty": "No matching candidates",
                "endingSoon": "Contract ends on {date}",
                "selected": "selected",
                "orderLater": "· set their order later from the cards",
                "submit": "Add to showcase ({n})"
            },
            "edit": {
                "published": "Live on the site",
                "publishedHint": "Switching off removes the card from the site instantly; data is kept.",
                "sortPlaceholder": "Empty = by followers",
                "sortError": "A whole number between 0 and 9999",
                "displayName": "Display name",
                "categoryHint": "Category: {category} — from the stream category, changed on the creator profile.",
                "extraTitle": "Extra details (shown when the card opens)",
                "bioTr": "Short bio · TR",
                "bioEn": "Short bio · EN",
                "bioEnPlaceholder": "If empty, the site shows the Turkish text",
                "tags": "Tags",
                "tagPlaceholder": "+ tag, Enter",
                "previewHint": "Preview of the site card. The image is the 1080×1080 copy from the profile page.",
                "customAvatar": "uploaded from the panel",
                "avatarPolling": "Preparing the image; it will appear here and in the list automatically…",
                "remove": "Remove from showcase",
                "removeConfirm": "Sure? Card details and image are deleted"
            },
            "toast": {
                "loadError": "Could not load creators",
                "updated": "{'@'}{username} updated",
                "shown": "{'@'}{username} is live on the site",
                "hidden": "{'@'}{username} hidden from the site",
                "reordered": "Order saved",
                "added": "{n} creators added; images on the way",
                "removed": "{'@'}{username} removed from the showcase",
                "updateError": "Update failed",
                "avatarQueued": "Image job queued for {'@'}{username}; ready in a few minutes",
                "avatarReady": "Image for {'@'}{username} is ready; list updated",
                "avatarQueueError": "Could not queue the image job",
                "avatarUploaded": "Image uploaded",
                "avatarUploadError": "Could not upload (images only, max 10 MB)"
            }
        },
        "content": {
            "title": "Content",
            "hint": "Team, awards, academy and FAQ on the website. Drag to reorder; a switched-off record stays off the site but keeps its data. The site updates within 5 minutes.",
            "tabs": { "team": "Team", "awards": "Awards", "courses": "Academy", "faq": "FAQ" },
            "published": "Live on the site",
            "hiddenTag": "hidden",
            "editing": "Editing…",
            "empty": "No records yet.",
            "dragHint": "Drag to reorder",
            "plainText": "Plain text; line breaks are kept, no links or formatting.",
            "enPlaceholder": "If empty, the site shows the Turkish text",
            "delete": "Delete",
            "deleteConfirm": "Sure? This cannot be undone",
            "image": { "empty": "No image", "upload": "Upload image", "replace": "Replace image", "remove": "Remove", "uploading": "Uploading…" },
            "team": {
                "label": "Team member", "new": "Add member", "name": "Full name", "role": "Title",
                "imageHint": "4:5 ratio, at least 800×1000. Uploaded to MinIO, served to the site through the public endpoint.",
                "certificates": "Certificates", "certTitle": "Certificate title", "certMeta": "Meta (issuer · place · date)",
                "certDescription": "Description", "certAdd": "+ Add certificate", "certRemove": "Remove certificate", "certCount": "{n} certificates",
                "group": "Team group", "groupHint": "Section in the team organisation chart on the site.", "founder": "Founder", "founderHint": "The founder is shown on a separate row above the management section.",
                "groups": { "management": "Management", "creators": "Creator Managers", "events": "Event Managers", "social": "Social Media" }
            },
            "awards": {
                "label": "Award", "new": "Add award", "year": "Year", "yearHint": "Empty = undated group (last on the site)", "undated": "Undated",
                "imageHint": "Square image, at least 800×800.", "title": "Title", "meta": "Meta", "description": "Description", "count": "{n} awards"
            },
            "courses": { "new": "Add course", "title": "Title", "text": "Text" },
            "faq": { "new": "Add question", "question": "Question", "answer": "Answer" },
            "toast": { "loadError": "Could not load content", "saved": "Saved", "saveError": "Could not save", "deleted": "Deleted", "uploadError": "Could not upload (images only)" }
        },
        "settings": {
            "title": "Site Settings",
            "hint": "Application status, ticker, contact, social media, counters and videos. Saved with one button; the site updates within 5 minutes.",
            "save": "Save and publish",
            "unsaved": "Unsaved changes",
            "publishNote": "Save and publish: the site shows the new settings within 5 minutes.",
            "sections": { "applications": "Applications", "ticker": "Ticker", "contact": "Contact", "social": "Social media", "stats": "Home counters", "videos": "Videos", "links": "Links" },
            "applications": { "open": "Applications open", "hint": "When off, the ticker says applications are closed and the form is replaced by a message.", "closedMessage": "Message when closed" },
            "ticker": { "hint": "Items that scroll after the application status.", "add": "+ Add item" },
            "contact": { "phoneDisplay": "Phone (shown)", "phoneHref": "Phone (dialled, tel:)", "email": "E-mail", "address": "Address", "directions": "Directions link", "whatsappDisplay": "WhatsApp (shown number)", "whatsappHref": "WhatsApp link (wa.me)", "workingHours": "Working hours", "whatsappHint": "If WhatsApp is empty, the WhatsApp card on the site and the post-application WhatsApp redirect are hidden." },
            "social": { "hint": "An empty account is not shown on the site.", "youtubeVideos": "YouTube videos page" },
            "stats": { "hint": "The four counters on the home page. A \"live\" counter is derived from the managed creator count in TAP (1,388 → 1.300+).", "value": "Value", "live": "Live", "liveValue": "from TAP", "liveHint": "Value comes from the active creator count in TAP", "add": "+ Add counter" },
            "videos": { "hint": "YouTube slots on the About page; when empty a placeholder links to the channel.", "about": "About", "mission": "Mission", "vision": "Vision" },
            "links": { "panel": "Panel (Backstage) URL", "appStore": "App Store link" },
            "toast": { "loadError": "Could not load settings", "saved": "Settings saved; the site updates within a few minutes", "saveError": "Could not save settings" }
        }
    },
    "siteApplications": {
        "title": "Site Applications",
        "hint": "Submissions from the haymenagency.com application and contact forms. New ones are 'New'; after a call 'Contacted', then 'Accepted' or 'Rejected'. Click a row for the message and notes.",
        "all": "All",
        "search": "Search name, e-mail, phone or TikTok",
        "empty": "No applications in this filter.",
        "column": { "date": "Date", "applicant": "Applicant", "category": "Category", "accounts": "Accounts", "status": "Status", "type": "Type" },
        "status": { "NEW": "New", "CONTACTED": "Contacted", "ACCEPTED": "Accepted", "REJECTED": "Rejected" },
        "type": { "APPLICATION": "Application", "CONTACT": "Contact" },
        "action": { "contacted": "Contacted", "accept": "Accept", "reject": "Reject" },
        "detail": { "message": "Message", "previousAgency": "Previous agency", "followers": "Follower range", "mailed": "E-mail", "mailedYes": "sent", "mailedNo": "not sent (no recipient configured)", "handled": "Last action", "note": "Note (internal)" },
        "toast": { "loadError": "Could not load applications", "updated": "Updated", "updateError": "Could not update" }
    },
    "wallet": { "requestWithdrawal": "Request a withdrawal" },
    "partners": {
        "nav": {
            "find": "Find creators",
            "creators": "My creators",
            "earnings": "My earnings",
            "admin": "Partners"
        },
        "off": {
            "title": "This section is turned off for this agency",
            "body": "Partner screens are not available for this agency right now. If this looks wrong, talk to your agency manager."
        },
        "unit": {
            "DIAMOND": "Diamonds",
            "USD": "Dollars"
        },
        "status": {
            "INVITED": "Invite sent",
            "ACTIVE": "Active",
            "SUSPENDED": "Suspended"
        },
        "payout": {
            "INVOICE": "By invoice",
            "WALLET": "To the app wallet"
        },
        "task": {
            "ACTIVENESS": "Activeness",
            "RANK_UP": "Rank up",
            "INCREMENTAL_REVENUE": "Incremental revenue",
            "REGIONAL": "Regional valid LIVE",
            "COMMISSION": "Regional / commission task",
            "OTHER": "Other tasks",
            "ROOKIE_MILESTONE": "Rookie milestone"
        },
        "taskHint": {
            "ACTIVENESS": "Staged task, per creator",
            "RANK_UP": "Moving up and keeping level, per creator",
            "INCREMENTAL_REVENUE": "TikTok pays the agency separately per creator",
            "REGIONAL": "Per cohort",
            "ROOKIE_MILESTONE": "New creator target"
        },
        "find": {
            "title": "Find creators",
            "desc": "Type a TikTok username and check it. If it fits, refer the creator.",
            "username": "TikTok username",
            "placeholder": "user.name",
            "check": "Check",
            "checking": "Checking…",
            "hint": "The check goes to TikTok and can take a few seconds.",
            "refer": "Refer",
            "phoneLabel": "Candidate phone (optional)",
            "phoneHint": "If you add it, the agency can contact {name} on this number. You can leave it empty; your referral still goes for approval.",
            "referNote": "Your referral goes to the agency for approval. Once approved, {name} is saved under your name; your share starts from the month they join the agency.",
            "referred": "Your referral for {name} was sent to the agency for approval.",
            "referError": "Could not refer. Try again in a moment.",
            "checkError": "Could not check. Try again in a moment.",
            "inviteType": "Invite type",
            "state": "Status",
            "checkedAt": "Checked",
            "recent": "Your recent checks",
            "recentEmpty": "You have not checked anyone yet.",
            "recheck": "Check again",
            "alreadyReferred": "Referred",
            "col": {
                "nickname": "Nickname",
                "username": "Username",
                "result": "Result",
                "time": "Time"
            },
            "status": {
                "ELIGIBLE": "Eligible",
                "NEEDS_TRIAL": "Needs a trial",
                "INVITED_PENDING": "Invite pending",
                "IN_OTHER_AGENCY": "In another agency",
                "INVITE_DISABLED": "Invites off",
                "MULTI_ACCOUNT": "Multiple accounts",
                "NOT_FOUND": "Not found",
                "OTHER": "Cannot refer",
                "IN_OUR_AGENCY": "Already in our agency",
                "ALREADY_REFERRED": "Referred by someone else",
                "AWAITING_APPROVAL": "Awaiting approval",
                "ALREADY_REFERRED_BY_YOU": "You already referred",
                "ALREADY_REFERRED_PENDING": "Referral pending"
            }
        },
        "creators": {
            "title": "My creators",
            "desc": "The creators you referred and the share you get from each this month.",
            "tab": {
                "AWAITING_APPROVAL": "Awaiting approval",
                "REJECTED": "Rejected",
                "ALL": "All",
                "ACTIVE": "In agency",
                "PENDING": "Waiting",
                "EXPIRED": "Share ended"
            },
            "status": {
                "AWAITING_APPROVAL": "Awaiting approval",
                "REJECTED": "Rejected",
                "ACTIVE": "In agency",
                "PENDING": "Waiting",
                "EXPIRED": "Share ended"
            },
            "stat": {
                "active": "In agency",
                "activeSub": "Creators with a running share",
                "pending": "Waiting",
                "pendingSub": "Not in the agency yet",
                "expired": "Share ended",
                "expiredSub": "{n} months used",
                "expiredSubNoPlan": "Share period is over",
                "month": "My share this month",
                "monthSub": "Estimate, month in progress"
            },
            "search": "Search creators",
            "col": {
                "creator": "Creator",
                "status": "Status",
                "referred": "Referred",
                "phone": "Candidate phone",
                "joined": "Joined",
                "window": "Share period",
                "diamonds": "Diamonds this month",
                "amount": "My share this month"
            },
            "waiting": "Waiting to join the agency",
            "awaiting": "Waiting for agency approval",
            "rejected": "Rejected by the agency",
            "window": "{n} / {total} mo",
            "windowOpen": "Month {n}",
            "empty": "No creators in this list.",
            "foot": "Your referral first goes to the agency for approval; once approved it becomes Waiting, and In agency when the creator joins. Your share starts from the month they join and lasts as long as your plan says. Amounts before the month ends are estimates. You can refer a rejected creator again."
        },
        "earnings": {
            "title": "My earnings",
            "desc": "Your share, payments and wallet, month by month.",
            "walletTx": "Wallet activity",
            "plan": "Your plan",
            "duration": "Period",
            "durationMonths": "{n} months per creator",
            "cap": "Monthly cap per creator",
            "payout": "Payment",
            "note": "Note",
            "totalLabel": "Total",
            "months": "Months",
            "empty": "No earnings yet.",
            "pick": "Pick a month on the left.",
            "status": {
                "PROJECTED": "Estimate",
                "CONFIRMED": "Confirmed",
                "PAID": "Paid"
            },
            "noteProjected": "Month in progress, may change",
            "noteConfirmed": "Waiting for payment",
            "invoice": "Invoice {no}",
            "detailTitle": "{month} breakdown",
            "detailSub": "{n} creators · total",
            "more": "+ {n} more creators",
            "col": {
                "yours": "Your share"
            },
            "foot": "When the month closes and TikTok's payment is final, the amount becomes Confirmed. Past months do not change afterwards."
        },
        "admin": {
            "title": "Partners",
            "desc": "People and companies that bring creators to the agency.",
            "tabPartners": "Partners",
            "tabPlans": "Share plans",
            "tabAwaiting": "Awaiting approval",
            "awaiting": {
                "title": "Referrals awaiting approval",
                "desc": "Referrals from partners do not count until approved. Once approved, the creator appears as \"Waiting\" in the partner's list; the share starts from the month they join.",
                "foot": "When you approve, we check again that nobody else has referred this creator in the meantime. The agency invitation is still sent separately as usual.",
                "empty": "No referrals awaiting approval.",
                "col": { "creator": "Creator", "partner": "Referred by", "result": "Check result", "phone": "Candidate phone", "date": "Date" },
                "partnerTag": "Partner",
                "eligible": "Eligible",
                "approve": "Approve",
                "reject": "Reject",
                "approved": "{'@'}{username} approved · \"Waiting\" in {partner}'s list",
                "rejected": "Referral for {'@'}{username} rejected",
                "error": "Could not complete. Please try again shortly.",
                "rejectTitle": "Reject referral",
                "rejectText": "The referral of {'@'}{username} by {partner} will be rejected. It will not count and no share will be created.",
                "reason": "Reason",
                "reasonPlaceholder": "Optional",
                "reasonHint": "The partner sees this text in My creators.",
                "cancel": "Cancel"
            }
        },
        "list": {
            "add": "Add partner",
            "search": "Search by name or e-mail",
            "filter": { "group": "Partner", "status": "Status", "plan": "Share plan" },
            "empty": "No partners yet.",
            "suspended": "{n} suspended",
            "invited": "{n} invite pending",
            "stat": {
                "active": "Active partners",
                "creators": "Creators they brought",
                "creatorsSub": "{n} not in the agency yet",
                "payable": "To pay this month",
                "payableSub": "Estimate, month in progress",
                "net": "Agency keeps from these creators",
                "netSub": "After partner share"
            },
            "col": {
                "partner": "Partner",
                "active": "In agency",
                "pending": "Waiting",
                "plan": "Share plan",
                "status": "Status"
            }
        },
        "detail": {
            "title": "Partner",
            "since": "since {date}",
            "suspend": "Suspend",
            "activate": "Activate",
            "edit": "Edit",
            "notFound": "Partner not found.",
            "stat": {
                "month": "Share this month",
                "paid": "Total paid",
                "paidSub": "Marked as paid"
            },
            "tab": {
                "creators": "Creators",
                "payouts": "Payments",
                "plan": "Share plan",
                "conflicts": "Conflicts"
            },
            "col": {
                "month": "Month",
                "creators": "Creators",
                "net": "Agency keeps",
                "amount": "Partner share"
            },
            "markPaid": "Mark as paid",
            "markPaidTitle": "{month} payment",
            "invoiceNo": "Invoice no",
            "invoicePlaceholder": "e.g. DM-2026-08",
            "walletNote": "Goes to the wallet, no invoice number needed",
            "paidDone": "Payment marked.",
            "confirmsAtEnd": "Confirmed at month end",
            "openPlan": "Open plan",
            "noPlan": "No plan assigned to this partner yet.",
            "conflicts": "Conflicts",
            "noConflicts": "No conflicts.",
            "conflictText": "is assigned to manager {manager} in the candidates list. {partner} referred them on {date}.",
            "conflictHint": "When both a manager and a partner try to bring the same person, you decide here.",
            "keepPartner": "Keep with partner",
            "giveManager": "Give to manager",
            "resolved": "Decision saved."
        },
        "drawer": {
            "planPlaceholder": "Select a plan",
            "addTitle": "Add partner",
            "editTitle": "Edit partner",
            "who": "Who?",
            "name": "Company or person name",
            "contact": "Contact person",
            "email": "Email",
            "phone": "Phone",
            "inviteNote": "An invite goes to their email when you save. They sign in on the normal login page with a password they choose and only see their own screens.",
            "plan": "Share plan",
            "months": "{n} months",
            "custom": "Custom · {name}",
            "partnerCount": "{n} partners",
            "noPlans": "No plans yet. You can make a custom plan for this partner below.",
            "makeCustom": "Make a custom plan for this partner",
            "access": "Access and payment",
            "showDiamonds": "Can see the creator's diamonds",
            "showDiamondsHint": "\"Diamonds this month\" column in My creators",
            "showTasks": "Can see the task breakdown",
            "showTasksHint": "Activeness, rank and incremental split in My earnings",
            "mfaRequired": "Two-step verification required",
            "mfaRequiredHint": "When on, the partner enters a second-step code at sign-in",
            "payout": "Payment method",
            "payoutInvoice": "Month end, by invoice",
            "payoutWallet": "To the app wallet",
            "account": "Account",
            "resend": "Resend invite",
            "resent": "Invite sent again.",
            "suspendConfirm": "Suspend {name}? They cannot sign in or refer new creators.",
            "saveInvite": "Save and invite",
            "saved": "Saved.",
            "invited": "Partner added, invite sent.",
            "saveError": "Could not save. Check the fields and try again."
        },
        "plans": {
            "add": "Add plan",
            "empty": "No share plans yet.",
            "search": "Search plans",
            "filter": { "group": "Plan", "owner": "Belongs to" },
            "template": "Template",
            "custom": "Custom",
            "col": {
                "name": "Plan",
                "owner": "Belongs to",
                "partners": "Partners",
                "from": "Effective",
                "duration": "Period",
                "cap": "Monthly cap",
                "tasks": "Tasks"
            }
        },
        "plan": {
            "title": "Share plan",
            "newName": "New plan",
            "name": "Plan name",
            "validity": "Effective",
            "validFrom": "From {month}",
            "validNext": "Starts from the next open month once saved",
            "validHint": "A change starts from the next open month; past months do not change.",
            "usedBy": "{n} partners use this plan: {names}",
            "forPartner": "This plan will belong to this partner only.",
            "copy": "Copy",
            "saved": "Saved. The new version starts from {month}.",
            "created": "Plan created.",
            "copied": "Plan copied.",
            "tasks": "Tasks",
            "tasksHint": "The rate the partner gets for each task. \"Agency keeps\": what TikTok pays the agency minus the creator's share.",
            "col": {
                "include": "Include",
                "task": "Task",
                "base": "Base",
                "rate": "Rate"
            },
            "base": {
                "NET": "Agency keeps",
                "GROSS": "Gross"
            },
            "excluded": "Not in the plan",
            "activenessNote": "Creators get 100% today, so the agency keeps 0; this row pays nothing for now.",
            "rules": "Rules",
            "rulesHint": "Of the \"Set rate\" rules the first match applies; \"Add rate\" rules that match are added on top. If none match, the rate in the task table applies.",
            "if": "IF",
            "then": "THEN",
            "min": "min",
            "max": "max",
            "allTasks": "All tasks",
            "addRule": "Add rule",
            "removeRule": "Remove rule",
            "moveUp": "Move up",
            "moveDown": "Move down",
            "delete": "Delete",
            "deleteConfirm": "Delete plan \"{name}\"? Past versions and earnings are kept; it only disappears from lists.",
            "deleted": "Plan deleted.",
            "tryPick": "Find creator",
            "tryPickPh": "Name, username…",
            "condOptions": "Rule options: creator's month in the agency, creator's monthly diamonds, stage reached in the task, creator's level, partner's creator count in the agency.",
            "cond": {
                "MONTHS_IN_AGENCY": "Creator's month in the agency",
                "CREATOR_MONTHLY_DIAMONDS": "Creator's monthly diamonds",
                "TASK_STAGE": "Stage reached in the task",
                "CREATOR_LEVEL": "Creator's level",
                "PARTNER_ACTIVE_CREATORS": "Partner's creators in the agency"
            },
            "action": {
                "SET": "Set rate",
                "ADD": "Add rate"
            },
            "unitMonth": "mo",
            "unitDiamond": "diamonds",
            "unitStage": "stage",
            "unitCreators": "creators",
            "durationCap": "Period and cap",
            "duration": "Share period per creator",
            "unlimited": "Unlimited",
            "durationHint": "Counted from the month the creator joins.",
            "cap": "Monthly cap per creator",
            "capHint": "Leave empty for no cap.",
            "capApplied": "The monthly cap per creator was applied.",
            "try": "Try it",
            "tryHint": "Test the plan on one real creator and month. It uses the plan as shown on screen, without saving.",
            "tryCreator": "Creator",
            "tryMonth": "Month",
            "tryRun": "Try",
            "simError": "Could not calculate. Check the username and month.",
            "simMonths": "Month {n} in the agency",
            "simActive": "{n} active creators",
            "sim": {
                "income": "TikTok → agency",
                "creator": "To creator",
                "base": "Left",
                "amount": "Share",
                "total": "Total",
                "stage": "Stage {n}",
                "applied": "Rule applied",
                "noRule": "None, task rate applies",
                "keeps": "Agency keeps"
            }
        }
    }
}
